// Polski

export default {
  borrow: {
    Bo1: "Pożyczka",
    Bo2: "Pomagamy Ci odkrywać więcej możliwości handlowych i produktów finansowych.",
    Bo3: "Zasady pożyczania walut",
    Bo4: "Jeśli",
    Bo5: "Zwrot w ciągu dni: Stałe oprocentowanie dla cyklu wynosi",
    Bo6: "Za zaległe płatności będą naliczane dzienne opłaty.",
    Bo7: "odsetki karne. Sugeruję dokładne rozważenie możliwości spłaty monet przed ich pożyczeniem, aby uniknąć niepotrzebnych dodatkowych opłat",
    Bo8: "Anulować",
    Bo9: "Potwierdzać",
    Bo10: "Zwróć monety",
    Bo11: "Uwaga: Adres wpłaty i adres spłaty są różne. Aby uniknąć błędów operacyjnych, upewnij się, że spłacasz monety na właściwy adres spłaty.",
    Bo12: "Adres portfela:",
    Bo13: "Wrócił do rewizji.",
    Bo14: "Powód odrzucenia:",
    Bo15: "kontynuować edycję",
    Bo16: "W trakcie sprawdzania — przesłano pomyślnie. Nasz zespół rozpatrzy Twój wniosek o pożyczkę w ciągu 24 godzin. Prosimy o sprawdzanie aktualizacji.",
    Bo17: "Zatwierdzono — kwota pożyczki wynosząca",
    Bo18: "Aby uzyskać szczegółowe informacje, możesz sprawdzić swoje konto monetowe.",
    Bo19: "Pożyczone dni",
    Bo20: "Kwota należna",
    Bo21: "Łącznie z odsetkami",
    Bo22: "Spłata jednym kliknięciem",
    Bo23: "Informacje o pożyczkach",
    Bo24: "Nazwa banku",
    Bo25: "Numer karty bankowej",
    Bo26: "Pożądana kwota pożyczki (USDT)",
    Bo27: "Identyfikacja osobista",
    Bo28: "Dowód osobisty (przód i tył)",
    Bo29: "Kliknij, aby przesłać",
    Bo30: "Pełne imię i nazwisko",
    Bo31: "Główny numer telefonu",
    Bo32: "Numer identyfikacyjny",
    Bo33: "Zarejestrowany adres",
    Bo34: "Aktualny adres zamieszkania",
    Bo35: "Dowód informacji o gwarantu",
    Bo36: "Imię i nazwisko gwaranta",
    Bo37: "Numer telefonu",
    Bo38: "Relacja z Klientem",
    Bo39: "Adres zamieszkania",
    Bo40: "Dowód dochodu (Wskazówka: możesz przesłać odcinki wynagrodzeń, zaświadczenia od pracodawcy itp.)",
    Bo41: "Zaświadczenie o dochodach",
    Bo42: "Dowód majątku (Wskazówka: możesz przesłać świadectwa własności, dowód pojazdu, dowód wpłaty itp.)",
    Bo43: "Dowód majątku",
    Bo44: "Inne dokumenty",
    Bo45: "Prześlij informacje o pożyczce",
    Bo46: "Prześlij przód i tył swojego dowodu osobistego",
    Bo47: "Prosimy o przesłanie dokumentu potwierdzającego dochód",
    Bo48: "Prześlij dowód posiadania majątku",
    Bo49: "Użytkownik pożyczający monety",
    Bo50: "Lista zwrotów",
    Bo51: "Pożyczka wiąże się z ryzykiem, a ostateczny wynik podlega faktycznej weryfikacji.",
    Bo52: "Dlaczego wybrać Pożyczkę?",
    Bo53: "Szybka akceptacja, przejrzyste odsetki i opłaty",
    Bo54: "Proszę wybrać bank udzielający pożyczki.",
    Bo55: "Bezpośrednia pożyczka bankowa, bez zabezpieczeń,",
    Bo56: "historia",
    Bo57: "Mnemoniczny",
    Bo58: "Mnemonika można używać do logowania się do aplikacji",
    Bo59: "Spowodować",
    Bo60: "Pogląd",
    Bo61: "Kopia",
    Bo62: "Niestety",
    Bo63: "Nie zniechęcaj się, dostosuj swoją strategię i spróbuj ponownie!",
    Bo64: "Gratulacje",
    Bo65: "Dobry znak! Kontynuuj dobrą pracę i osiągaj jeszcze więcej",
    Bo66: "Kontynuuj składanie zamówień",
    Bo67: "Aby zapewnić bezpieczeństwo swoich środków, prosimy o zwrócenie szczególnej uwagi na następujące środki ostrożności przy spłacie:",
    Bo68: "1. Używaj wyłącznie oficjalnego adresu spłaty podanego przez platformę: Każdy adres spłaty uzyskany ze źródeł innych niż oficjalne kanały platformy jest nieważny.",
    Bo69: "2. Uważaj na oszustwa: Jeśli ktoś kontaktuje się z Tobą prywatnie i podaje tzw. adres do spłaty, nie ufaj mu tak łatwo.",
    Bo70: "3. Odpowiedzialność za bezpieczeństwo funduszu: Jeżeli środki zostaną utracone w wyniku użycia błędnego adresu do spłaty, platforma nie będzie ponosić odpowiedzialności i może ponieść odpowiednią odpowiedzialność prawną zgodnie z prawem.",
    Bo71: "Prosimy o zachowanie czujności i zadbanie o to, aby operacje spłaty odbywały się formalnymi kanałami, aby skutecznie chronić bezpieczeństwo Twojego mienia!",
    Bo72: "Uwaga dotycząca bezpieczeństwa",
    Bo73: "Rozumiem",
    Bo74: "Twoje konto bieżące jest kontem wirtualnym i wszystkie środki na nim służą wyłącznie do symulowanego handlu i nie mogą być wykorzystywane do rzeczywistych operacji wypłat. Prosimy zachować czujność i chronić się przed związanymi z tym zagrożeniami!"
  },
  other: {
    back_order: "Monity o wypłatę",
    review_failed: "recenzja nie powiodła się",
    try_again: "spróbuj ponownie"
  },
  withdraw: {
    memoTip: "Proszę wypełnić notatkę",
    memoWar: "Poszukaj kopii na stronie depozytu"
  },
  findPwd: {
    code: "kod"
  },
  Purchase: {
    Pu1: "Zakup",
    Pu2: "Wybierz opcję Zapłać",
    Pu3: "Wybierz metodę płatności",
    Pu4: "Potwierdź zamówienie",
    Pu5: "Przybył",
    Pu6: "balansować",
    Pu7: "ilość zakupu",
    Pu8: "kwota",
    Pu9: "ilość sprzedaży",
    Pu10: "Wszystko",
    Pu11: "Minimalna wartość nie może być mniejsza niż",
    Pu12: "Maksymalna wartość nie może być większa niż",
    Pu13: "Cena orientacyjna",
    Pu14: "bezpłatny",
    Pu15: "Kup teraz",
    Pu16: "Sprzedaj teraz",
    Pu17: "kupić",
    Pu18: "Sprzedać",
    Pu19: "Wybierz metodę płatności",
    Pu20: "Metody płatności",
    Pu21: "Dodaj metodę wypłaty",
    Pu22: "Dodać",
    Pu23: "nazwa użytkownika",
    Pu24: "Numer karty bankowej",
    Pu25: "Kod IFSC",
    Pu26: "telefon",
    Pu27: "Potwierdzać",
    Pu28: "Potwierdź zamówienie",
    Pu29: "Tak!",
    Pu30: "Pomyślnie dokonałeś wypłaty",
    Pu31: "Status",
    Pu32: "Zakończony",
    Pu33: "Otrzymana kwota",
    Pu34: "Kupić",
    Pu35: "Sprzedać",
    Pu36: "Nazwa waluty",
    Pu37: "Łączna kwota transakcji",
    Pu38: "Ilość",
    Pu39: "Cena",
    Pu40: "Status",
    Pu41: "Czas",
    Pu42: "Cena",
    Pu43: "Udany",
    Pu44: "Przegrany",
    Pu45: "Przetwarzanie",
    Pu46: "Wygasły",
    Pu47: "Odrzucić",
    Pu48: "z",
    Pu49: "Oficjalna strona internetowa",
    Pu50: "Biała księga",
    Pu51: "Wstęp",
    Pu52: "Oficjalny link do strony internetowej"
  },
  nhome: {
    Nh1: "Jedna z największych giełd kryptowalut na świecie",
    Nh2: "Zrekrutowałem ponad milion zarejestrowanych użytkowników na platformie, z dziennym wolumenem obrotu przekraczającym 10000000000 USDT. Dołączając do nas, handluję również jako główny trader, co ułatwia inwestowanie",
    Nh3: "Wolumen obrotu",
    Nh4: "użytkownicy",
    Nh5: "Zróżnicowane produkty i usługi",
    Nh6: "- Wybierz więcej usług i odkryj nieskończone możliwości",
    Nh7: "Handel kontraktami futures",
    Nh8: "Handel spotowy",
    Nh9: "Handel opcjami",
    Nh10: "Handel Fiatem",
    Nh11: "Najwyższy przepływ, najniższy wskaźnik zamówień, wydajne nowe projekty walutowe wysokiej jakości z doskonałą płynnością.",
    Nh12: "Zapewnij setki wysokiej jakości usług handlu walutami, bezpiecznych i niezawodnych, stawki transakcyjne na rynku są najniższe",
    Nh13: "Największa liczba uczestników, fair play, wysokie kursy",
    Nh14: "Szybki zakup walut jednym kliknięciem zapewnia wydajny i wygodny system handlu w czasie rzeczywistym. Twoje środki mogą wejść i wyjść w ciągu kilku sekund..",
    Nh15: "Trend rynkowy",
    Nh16: "więcej",
    Nh17: "Nasze zalety",
    Nh18: "najlepszy na świecie system kontroli ryzyka bezpieczeństwa",
    Nh19: "Kompleksowa ochrona zasobów użytkownika",
    Nh20: "——To Twoja zaufana platforma",
    Nh21: "Tryb przechowywania offline",
    Nh22: "Szyfrowanie wieloczynnikowe",
    Nh23: "Monitorowanie platformy 24*7 dni",
    Nh24: "Wiodąca platforma handlu aktywami cyfrowymi",
    Nh25: "—— Bogate usługi w zakresie handlu aktywami cyfrowymi i zarządzania aktywami w celu zaspokojenia zróżnicowanych potrzeb handlowych",
    Nh26: "Rozpocznij handel w dowolnym miejscu i czasie",
    Nh27: "Pełne wsparcie dla systemów IOS i Android.",
    Nh28: "Zeskanuj kod QR, aby pobrać",
    Nh29: "Wykres wzrostu",
    Nh30: "Odrzuć listę",
    Nh31: "Lista wolumenu transakcji",
    Nu32: "Wiodąca na świecie platforma handlu aktywami cyfrowymi",
    Nu33: "- Bogate usługi w zakresie handlu aktywami cyfrowymi i zarządzania aktywami w celu zaspokojenia różnorodnych potrzeb handlowych",
    Nu34: "Zacznij handlować i przeżyj najlepszą podróż po kryptowalutach",
    Nu35: "Minimalna długość nie powinna być mniejsza niż 5",
    Nu36: "Szybki zakup monet",
    Nu37: "Kup monety",
    Nu38: "1. Pojedyncza transakcja o wartości 300 W – 1 miliard IDR.",
    Nu39: "2. Po otrzymaniu rachunku płatniczego prosimy o zrealizowanie przelewu w wyznaczonym terminie. W przypadku przekroczenia podanego czasu prosimy o kontakt z obsługą klienta w celu potwierdzenia ważności zamówienia.",
    Nu40: "3.dokonując przelewu prosimy o podanie rachunku transakcyjnego lub UID rachunku, a także szczegółowy zrzut ekranu przelewu oraz ważny dowód osobisty",
    Nu41: "Kliknij, żeby wiedzieć"
  },
  common: {
    logins: "Logowanie...",
    login: "Zaloguj się",
    register: "Zapisać się",
    loginregister: "Zaloguj się/Zarejestruj się",
    logout: "Wyloguj się",
    tip: "Wskazówka",
    logintip: "proszę się najpierw zalogować",
    expect: "Czekamy na oczekiwania!",
    delete: "Czy potwierdzasz usunięcie?",
    nodata: "Brak rekordów",
    set: "Ustawić",
    update: "Modyfikować",
    slogan: "50 najlepszych cyfrowych kantorów walutowych na świecie",
    subslogan: "Agencja państwowa gwarantuje bezpieczeństwo majątku",
    more: "Więcej",
    please: "Proszę",
    pleaseselect: "Wybierać",
    searchplaceholder: "Wprowadź symbol monety...",
    searchplaceholderswap: "Wprowadź symbol zamiany...",
    loading: "Załadunek...",
    close: "Zamknąć",
    ok: "OK",
    fillComplete: "Proszę podać pełne informacje"
  },
  header: {
    index: "Dom",
    otc: "OTC",
    exchange: "Miejsce",
    xiaoxi: "Wiadomość",
    kefu: "Pomoc",
    login: "LOGIN",
    register: "REJESTR",
    asset: "ZALETA",
    otcOrder: "ZAMÓWIENIE",
    ucenter: "KONTO",
    service: "Ogłoszenie",
    downloadapp: "Zeskanuj kod, aby pobrać i zainstalować",
    appdownlaod: "Pobierz aplikację",
    usercenter: "Centrum użytkownika",
    helpcenter: "CENTRUM POMOCY",
    aboutus: "O",
    partner: "Partner",
    bzb: "BZB EKO",
    assetmanage: "Finanse",
    trademanage: "Giełda",
    activity: "Błyskawica",
    lab: "Laboratorium BIPPAX",
    ctc: "Wymiana C2C",
    labdetail: "Laboratorium Błyskawicy BIPPAX",
    invite: "Partner promujący",
    whitepaper: "Biała księga",
    scandownload: "Pobierz aplikację",
    innovationmanage: "Innowacja",
    swap1: "Umowa",
    swap2: "Zamień (np.)",
    swap3: "CFD",
    swap4: "Drugi",
    cexchange: "QuikExchange",
    option: "Umowa opcyjna",
    news: "Aktualności"
  },
  sectionPage: {
    ptaqTitle: "Bezpieczeństwo platformy",
    ptaqContent: "Algorytm skrótu służy do szyfrowania wiodącego na świecie uwierzytelniania bezpieczeństwa",
    ptslTitle: "Siła platformy",
    ptslContent: "Największa na świecie platforma handlu bitcoinami",
    newsTitle: "Centrum Wiadomości",
    brandTitle: "O BIPPAX",
    brandDetail: "Szczery |  Targi |  Entuzjazm |  Otwarte",
    brandDesc1: "BIPPAX został założony przez grupę pierwszych uczestników i maniaków Bitcoina. Główni członkowie zespołu pochodzą ze znanych przedsiębiorstw, takich jak Google, Microsoft, Alibaba, Tencent i tak dalej. Posiada głęboką siłę badawczo-rozwojową oraz bogate doświadczenie w obsłudze produktów internetowych.",
    brandDesc2: "BIPPAX znajduje się w podstawowym dostawcy usług blockchain, zajmującym się dostarczaniem wysokiej jakości platformy handlu zaszyfrowanymi aktywami dla użytkowników na całym świecie, przestrzegając podstawowej zasady „NIE BĄDŹ ZŁY”, utrzymując uczciwą, uczciwą i entuzjastyczną obsługę klientów oraz witając wszystkich partnerów/projekty, które są korzystne dla podstawowych interesów użytkowników z otwartym podejściem.",
    gettingstart: "GORĄCO | Przewodnik dla początkujących",
    officialstart: "Oficjalna obsługa klienta BIPPAX",
    oneminutebuy: "Transakcja walutowa",
    oneminutebuytips: "Użyj jednego zasobu cyfrowego, aby bezpośrednio wymienić go na inny",
    baseknow: "Transakcja kontraktowa",
    baseknowtips: "Dwustronny handel wirtualnymi towarami T+0 w formie umowy barterowej",
    baseexchange: "Umowa opcyjna",
    baseexchangetips: "Jest instrumentem pochodnym aktywów cyfrowych",
    usersocial: "Szybka wymiana",
    usersocialtips: "Szybko wymieniaj zasoby cyfrowe",
    mainboard: "Płyta Główna",
    preview: "Poprzedni",
    nextpage: "Następny",
    downloadwhite: "Pobierz Białą księgę"
  },
  nav: {
    ptjy: "Handel platformowy",
    ptaq: "Bezpieczeństwo platformy",
    ptsl: "Siła platformy",
    xwzx: "Centrum Wiadomości",
    fabu: "reklama"
  },
  progress: {
    already: "Trzeba kopać",
    total: "Ilość wydobywalnej rudy 6 miliardów BHB"
  },
  service: {
    USDT: "USDT",
    BTC: "BTC",
    ETH: "ETH",
    CUSTOM: "Przychylność",
    COIN: "Moneta",
    symbol: "Para transakcyjna",
    favor: "Przychylność",
    NewPrice: "Ostatni",
    ExchangeNum: "Kwota",
    Change: "Zmiana",
    OpenPrice: "Cena otwarta",
    PriceTrend: "Trend cenowy",
    Operate: "Działać",
    Exchange: "Giełda",
    trading: "Giełda",
    high: "Wyższy",
    low: "Niżej"
  },
  swapAssets: {
    Br1: "Zwrot zakupu",
    Br2: "Zakup w ramach subskrypcji",
    Br3: "Przelew na konto kontraktowe",
    Br4: "Przenieś konto kontraktowe",
    Br5: "Zyski i straty na kontraktach wieczystych",
    Br6: "Koniec",
    Br7: "Konto kontraktowe (standard U)",
    Br8: "Saldo portfela",
    Br9: "Aktualna cena",
    Br10: "Otwórz więcej",
    Br11: "Na wolnym powietrzu",
    Br12: "Ukryj inne umowy",
    Br13: "Pozycja zamykania jednym kliknięciem",
    Br14: "Anuluj wszystkie zamówienia",
    Br15: "Korekta salda kontraktu wieczystego"
  },
  exchange: {
    wholehog: "Cały wieprz",
    coin: "Moneta",
    symbol: "Para transakcyjna",
    lastprice: "Ostatni",
    daychange: "Zmiana",
    market: "Rynki",
    favorite: "Wyraźny",
    do_favorite: "Zebrane",
    cancel_favorite: "Anuluj zebrane",
    type: "Typ",
    dealamount: "Zakończ kwotę",
    high: "Wysoki",
    low: "Niski",
    vol: "24H tom",
    buy: "Kupić",
    sell: "Sprzedać",
    limited_price: "Ograniczona cena",
    market_price: "Cena rynkowa",
    fees_rate: "stawka opłaty",
    balance: "salda",
    or: "Lub",
    starttrade: "Handluj teraz!",
    canuse: "Dostępny",
    recharge: "Depozyt",
    buyprice: "Kup cenę",
    buynum: "Kup kwotę",
    amount: "Kwota",
    buyin: "Kupić",
    disablebuyin: "Zakup na rynku wyłączony",
    buytip: "Optymalny zakup",
    sellprice: "Cena sprzedaży",
    sellnum: "Sprzedaj kwotę",
    sellout: "Sprzedać",
    disablesellout: "Sprzedaż na rynku wyłączona",
    selltip: "Optymalna sprzedaż",
    curdelegation: "Delegat",
    hisdelegation: "Delegat Historii",
    realtransaction: "Transakcje rynkowe",
    num: "Kwota",
    price: "Cena",
    direction: "Kierunek",
    time: "Czas",
    stall: "Stoisko",
    total: "Całkowity",
    traded: "Zrobione",
    action: "Działanie",
    undo: "Anulować",
    delegationnum: "Kwota delegata",
    done: "Zrobione",
    status: "Status",
    finished: "Gotowy",
    canceled: "Odwołany",
    parted: "Rozstał się",
    tip: "Wskazówka",
    buyamounttip: "wprowadź kwotę zakupu",
    buyamounttipwarning: "kup kwotę nie większą",
    success: "prześlij sukces!",
    pricetip: "wprowadź cenę zakupu",
    pricetipwarning: "cena zakupu nie wyższa",
    sellamounttip: "wprowadź kwotę sprzedaży",
    sellamounttipwarning: "sprzedaj kwotę nie większą",
    sellpricetip: "wprowadź cenę sprzedaży",
    sellpricetipwarning: "cena sprzedaży nie wyższa",
    undotip: "Potwierdź Cofnij?",
    cancelsuccess: "Anuluj zamówienie Pomyślnie",
    marketprice: "Cena rynkowa",
    expand: {
      time: "czas",
      price: "cena",
      amount: "kwota",
      fee: "opłata"
    },
    realtime: "czasie rzeczywistym",
    kline: "KLinia",
    depth: "Głębokość",
    publishstate0: "Zaraz się zacznie. Proszę czekać....",
    publishstate1: "To się wkrótce skończy. Proszę czekać...",
    publishstate2: "Konsolidacja zamówień. Proszę czekać...",
    publishstate3: "Konsolidacja dobiegła końca. Prosimy o swobodę handlu....",
    publishdetail: "Więcej szczegółów",
    publishprice: "Cena",
    publishamount: "Kwota",
    publishcounttxt0: "Zacznij po",
    publishcounttxt1: "Zakończ po",
    publishcounttxt2: "Wolny handel po",
    publishcounttxt3: "Koniec aktywności!",
    dateTimeDay: "D",
    dateTimeHour: "H",
    dateTimeMinutes: "M",
    dateTimeSeconds: "S",
    moredetail: "Zobacz więcej"
  },
  swap: {
    Sw1: "Zwiększ marżę",
    Sw2: "Zmniejsz marżę",
    Sw3: "Zwiększyć",
    Sw4: "Zmniejszyć",
    Sw5: "Margines",
    Sw6: "Maksymalnie dozwolone",
    Sw7: "Następna cena wymuszonego wyrównania wynosi",
    Sw8: "Wskaźnik dźwigni po wynosi",
    Sw10: "Zwiększ marżę kontraktową",
    Sw11: "Zmniejsz marżę kontraktową",
    Sw12: "Tekst opisowy",
    Spsl1: "Rzeczywisty czas wyzwalania",
    Spsl2: "Rzeczywista liczba wyzwalaczy",
    Spsl3: "Rzeczywisty kierunek wyzwalania",
    Spsl4: "Rzeczywista cena wywoławcza",
    contract: "Umowa",
    swapindex: "Wieczny",
    coin: "Moneta",
    symbol: "Para monet",
    volume: "Tom",
    lastprice: "Ostatni",
    daychange: "Zmiana",
    market: "Rynki",
    favorite: "Wyraźny",
    do_favorite: "Zebrane",
    cancel_favorite: "Anuluj zebrane",
    type: "Typ",
    dealamount: "Zakończ kwotę",
    high: "Wysoki",
    low: "Niski",
    vol: "24H tom",
    buy: "Kupić",
    sell: "Sprzedać",
    limited_price: "Ograniczona cena",
    market_price: "Cena rynkowa",
    spot_price: "Cena wywoławcza",
    fees_rate: "stawka opłaty",
    balance: "salda",
    or: "Lub",
    starttrade: "Handluj teraz!",
    canuse: "Dostępny",
    recharge: "Depozyt",
    buyprice: "Kup cenę",
    buynum: "Kup kwotę",
    amount: "Kwota",
    buyin: "Kupić",
    disablebuyin: "Zakup na rynku wyłączony",
    buytip: "Optymalny zakup",
    sellprice: "Cena sprzedaży",
    sellnum: "Sprzedaj kwotę",
    sellout: "Sprzedać",
    disablesellout: "Sprzedaż na rynku wyłączona",
    selltip: "Optymalna sprzedaż",
    curdelegation: "Delegat",
    hisdelegation: "Delegat Historii",
    realtransaction: "Transakcje rynkowe",
    num: "Kwota",
    price: "Cena",
    direction: "Kierunek",
    time: "Czas",
    stall: "Stoisko",
    total: "Całkowity",
    traded: "Zrobione",
    action: "Działanie",
    undo: "Anulować",
    delegationnum: "Kwota delegata",
    done: "Zrobione",
    status: "Status",
    finished: "Gotowy",
    canceled: "Odwołany",
    parted: "Rozstał się",
    tip: "Wskazówka",
    buyamounttip: "wprowadź kwotę zakupu",
    buyamounttipwarning: "kup kwotę nie większą",
    success: "prześlij sukces!",
    pricetip: "wprowadź cenę zakupu",
    pricetipwarning: "cena zakupu nie wyższa",
    sellamounttip: "wprowadź kwotę sprzedaży",
    sellamounttipwarning: "sprzedaj kwotę nie większą",
    sellpricetip: "wprowadź cenę sprzedaży",
    sellpricetipwarning: "cena sprzedaży nie wyższa",
    undotip: "Potwierdź Cofnij?",
    cancelsuccess: "Anuluj zamówienie Pomyślnie",
    marketprice: "Cena rynkowa",
    expand: {
      time: "czas",
      price: "cena",
      amount: "kwota",
      fee: "opłata"
    },
    realtime: "czasie rzeczywistym",
    kline: "KLinia",
    depth: "Głębokość",
    open: "Otwarte",
    close: "Zamknąć",
    latestdeal: "Najnowsza oferta",
    myswapaccount: "Moje konto wymiany",
    accountmode: "Wzór",
    accountmargin: "Wpływ",
    accountquanyi: "Słuszność",
    profitandloss: "Niezrealizowane zyski",
    principalAmount: "Wykorzystać. Margines",
    positionAmount: "Używany margines",
    frozenAmount: "Zamrożony margines",
    principalRate: "Współczynnik marży",
    zijinhuazhuan: "Przenosić",
    up: "L",
    down: "S",
    canup: "Maks. L",
    candown: "Maks. S",
    cancloseup: "Maks.(S)",
    canclosedown: "Maks. (L)",
    openup: "Otwórz Długie",
    opendown: "Otwórz skrót",
    closeup: "Zamknij krótko",
    closedown: "Zamknij Długie",
    currentposition: "Otwarte pozycje",
    assetsdetail: "Transakcje",
    marginMode1: "odizolowany",
    marginMode2: "Przechodzić",
    modifyMarginModeTitle: "Zmodyfikuj tryb depozytu zabezpieczającego konto",
    modifyLeverage: "Dostosuj dźwignię",
    moredetail: "Zobacz więcej",
    shareNumber: "ciąg dalszy",
    entrustprice: "Cena",
    triggleprice: "Spust",
    openvolume: "Długi tom",
    closevolume: "Krótki tom",
    triggleplaceholder: "Domyślną ceną jest cena rynkowa",
    marketpriceplaceholder: "Sprzedam po najlepszej cenie",
    levmaxtip: "Dźwignia nie powinna przekraczać wartości Max",
    levmintip: "Dźwignia nie powinna być niższa niż min",
    marginModeSuccessTip: "Modyfikuj sukces.",
    noenoughbalance: "Niewystarczająca równowaga",
    pleaseinputopenvolume: "Głośność powinna przekraczać 0",
    pleaseinputcorrectopenvolume: "Wprowadź prawidłową głośność",
    pleaseinputrightentrustprice: "Proszę podać poprawną cenę",
    noenoughposition: "Niewystarczająca pozycja",
    pleaseinputclosevolume: "Głośność powinna przekraczać 0",
    pleaseinputcorrectclosevolume: "Wprowadź prawidłową głośność",
    pos_Pl: "PL.",
    pos_Ratio: "Stosunek PL",
    pos_pos: "Pozycja",
    pos_canClose: "Stanowisko Ava",
    pos_openPrice: "Cena otwarta",
    pos_leverage: "Wpływ",
    pos_margin: "Cur Margin",
    pos_mRatio: "Współczynnik marży",
    pos_cmRatio: "Utrzymuj współczynnik",
    pos_long: "Długi",
    pos_short: "Krótki",
    ent_entrustType: "Otwórz/zamknij",
    ent_direction: "Kierunek",
    ent_type: "Typ",
    ent_trigglePrice: "Cena wywoławcza",
    ent_entrustPrice: "Powierz cenę",
    ent_tradedPrice: "Cena handlowa",
    ent_margin: "Margines",
    ent_volume: "Tom",
    ent_status: "Status",
    ent_status1: "Powierzenie",
    ent_status2: "Odwołany",
    ent_status3: "Zaufanie nie powiodło się",
    ent_status4: "Sprzedawany",
    ent_statusblast: "Podmuch",
    ent_pl: "P/L",
    ent_fee: "Opłata",
    triggerpriceshouldbigger: "Cena wywoławcza powinna przekraczać 0"
  },
  ctc: {
    title: "Sprzedaż jednym kliknięciem ● Gwarancja platformy ● Bezpieczeństwo",
    desc: "Aktywami kryptograficznymi zarządza BIPPAX, a akceptor świadczy usługi wymiany.",
    buyin: "Kupić",
    sell: "Sprzedać",
    buyprice: "Kup cenę",
    sellprice: "Cena sprzedaży",
    buynum: "Kup kwotę",
    sellnum: "Sprzedaj kwotę",
    payamount: "Zapłata",
    getamount: "Zapłata",
    avabalance: "Dostępny",
    time: "Data handlu",
    tip: "Ogłoszenie",
    notice: "Ogłoszenie",
    notice1: "1. Obszar legalnego obrotu walutami to transakcja na aktywach pomiędzy użytkownikami i akceptantami. Środki nie są przesyłane na platformę, a platforma nie akceptuje doładowań/przelewów w RMB;",
    notice2: "2. Akceptanci legalnych transakcji walutowych przeszli certyfikację z użyciem prawdziwego imienia i nazwiska, oferując marże transakcyjne, a tokeny są hostowane przez platformę, dzięki czemu możesz mieć pewność, że można je wymienić;",
    notice3: "3. Godzina obsługi akceptanta wynosi 09:00-21:00 dziennie. Akceptacja następuje w ciągu 30 minut od przyjęcia zamówienia, a niezakończona dwugodzinna transakcja zostaje anulowana;",
    notice4: "4. W celu obsługi kart bankowych w legalnym obszarze obrotu walutami konieczne jest przelanie środków przy użyciu konta uwierzytelnionego prawdziwym imieniem i nazwiskiem;",
    notice5: "5. Aby zapewnić bezpieczeństwo środków transakcyjnych, legalna transakcja walutowa wymaga od użytkowników uwierzytelnienia przy użyciu prawdziwego imienia i nazwiska;",
    payType: "Zapłać konto",
    receiveType: "Otrzymaj konto",
    moneyTips: "Powyższa cena ma charakter wyłącznie poglądowy. Proszę zapoznać się z rzeczywistą kwotą rozliczenia po złożeniu kolejnego zamówienia.",
    verifyset: "Prawdziwe imię/hasło zasobu",
    payset: "Ustawienia płatności",
    trade: "Giełda",
    input50tips: "Wprowadź liczbę z zakresu od 50 do 50 000",
    bank: "Karta bankowa",
    alipay: "Alipay",
    wechatpay: "Wechat",
    payaccountset: "Ustawienia konta płatniczego",
    useselfaccount: "Pamiętaj, aby używać konta uwierzytelnionego przy użyciu prawdziwego imienia i nazwiska.",
    orderSn: "Nr zamówienia",
    tradetime: "Data wymiany",
    direction: "Kierunek",
    amount: "Kwota (USDT)",
    money: "Razem (CNY)",
    price: "Cena (CNY)",
    status: "Status",
    operate: "Działać",
    moredetail: "Więcej szczegółów"
  },
  cexchange: {
    title: "Działalność BZB",
    desc: "BZB Coin ● Jednym kliknięciem ● Zyskaj codziennie",
    quantity: "AktywnośćZakupowana ilość",
    inputtips1: "Liczba niestandardowych",
    choosecurrency: "Wybierz walutę",
    all: "Wszystko",
    totalpay: "Waluta Kwota zapłaconej kwoty",
    restricted: "Całość dzisiaj ograniczona",
    currentprice: "Aktualna cena",
    nextprice: "Cena kolejnej emisji",
    confirmpay: "Potwierdź płatność",
    assets: "Aktywa:",
    loginFirst: "Proszę się zalogować",
    success: "Gratulacje, wymiana przebiegła pomyślnie!",
    tip: "Porady",
    confirm: "Potwierdź wskazówki",
    confirmmsg: "Czy na pewno chcesz wymienić BZB?",
    ok: "OK",
    cancel: "Anulować"
  },
  subscribe: {
    Su1: "Strona ze szczegółami",
    Su2: "Prenumerata",
    Su3: "Nowa subskrypcja walutowa",
    Su4: "Do rozpoczęcia",
    Su5: "W toku",
    Su6: "Do ogłoszenia",
    Su7: "Dystans",
    Su8: "Start",
    Su9: "Cena emisyjna",
    Su10: "Oczekiwany wskaźnik zysków i strat",
    Su11: "Czas rozpoczęcia",
    Su12: "Czas publikacji",
    Su13: "Bliższe dane",
    Su14: "Prenumerata",
    Su15: "Rekord subskrypcji",
    Su16: "Nazwa waluty",
    Su17: "Cena emisyjna",
    Su18: "Cena emisyjna",
    Su19: "Liczba zwycięskich ofert",
    Su20: "Kwota zwrotu",
    Su21: "Czas",
    Su22: "Status",
    Su23: "Czas",
    Su24: "Kwota abonamentu",
    Su25: "Waluta subskrypcji",
    Su26: "Cena emisyjna",
    Su27: "Oczekiwany zysk i strata",
    Su28: "Limit subskrypcji",
    Su29: "Godzina rozpoczęcia subskrypcji",
    Su30: "Godzina zakończenia subskrypcji",
    Su31: "Czas publikacji wyników",
    Su32: "Oczekiwany czas uruchomienia",
    Su33: "Kwota abonamentu",
    Su34: "Waluta",
    Su35: "Kwota abonamentu",
    Su36: "Czas subskrypcji",
    Su37: "Status",
    Su38: "Do ogłoszenia",
    Su39: "Opublikowany",
    Su40: "Informacje o projekcie",
    Su41: "Dostępne saldo",
    Su42: "Zastosuj natychmiast",
    Su43: "Wszystko",
    Su44: "Hasło płatności"
  },
  option: {
    minute: "min",
    enter: "Proszę wejść",
    title: "Umowa opcyjna",
    buyupreward: "Kup Pulę Nagród",
    buydownreward: "Sprzedaj pulę nagród",
    quantity: "Kwota zakładu",
    myamount: "Moja kwota zakładu",
    buyup: "Zwyżkowy",
    buydown: "Niedźwiedzi",
    history: "Historia",
    seriers: "NIE.",
    period: "",
    currentoption: "Zakres czasu",
    openprice: "Cena otwarta",
    currentprice: "Aktualna cena",
    openprice1: "Cena otwarta",
    closeprice: "Zamknij cenę",
    opentime: "Czas otwarty",
    closetime: "Czas zamknięcia",
    progress: "Postęp",
    loginFirst: "Najpierw zaloguj się!",
    selectAmount: "Proszę wybrać kwotę",
    balancenotenough: "Banans to za mało!",
    betsuccess: "Gratulacje! Zakład udany!",
    noopening: "Teraz nie ma otwierania!",
    col_createTime: "Stwórz czas",
    col_direction: "Kierunek",
    col_result: "Wynik",
    col_optionNo: "NIE.",
    col_betAmount: "Kwota zakładu",
    col_rewardAmount: "Kwota nagrody",
    col_fee: "Opłata otwarta",
    col_winfee: "Opłata za nagrodę",
    win: "Wygrać",
    lose: "Stracić",
    wait: "Otwór",
    avaliablebalance: "Dostępne saldo",
    login: "Proszę się zalogować",
    kline: "Cytaty w czasie rzeczywistym",
    or1: "Harga terkini",
    or2: "Masa pertaruhan",
    or3: "Jumlah pertaruhan",
    or4: "Mata wang pertaruhan",
    or5: "Jumlah leżał",
    or6: "Harga semasa adalah harga pelaksanaan",
    or7: "Sejarah perdagangan",
    or8: "Szanse",
    or9: "Premia",
    or10: "Przeczytaj ponownie",
    or11: "Sila pilih 4 jumlah pertaruhan USDT yang biasa"
  },
  otc: {
    ad: "Reklama",
    buyin: "Kupić",
    sellout: "Sprzedać",
    merchant: "Kupiec",
    applymerchant: "Zastosuj Sprzedawcę",
    volume: "Tom",
    paymethod: "Metoda płatności",
    amount: "Kwota",
    price_coin: "Cena/moneta",
    operate: "Działanie",
    validate: "Proszę najpierw zweryfikować",
    sell: "sprzedać",
    buy: "kupić",
    transaction: "Transakcje handlowe",
    buttontxt: "Zostań sprzedawcą",
    title: "Giełda OTC",
    desc: "Wygodna, bezpieczna i szybka sprzedaż cyfrowej waluty",
    title1: "Strojenie dynamiczne",
    desc1: "Wahania w czasie rzeczywistym w zależności od ceny rynkowej",
    title2: "Brak opłat",
    desc2: "To, co widzisz, jest tym, co dostajesz. Oprócz ceny sprzedaży platforma nie pobiera żadnych opłat za obsługę",
    title3: "Natychmiastowa transakcja",
    desc3: "Wprowadzenie usług platformy dla handlowców, inteligentne dopasowywanie, zamykanie zamówień, brak konieczności czekania na kojarzenie",
    title4: "Gwarancja platformy",
    desc4: "Firma zajmująca się certyfikacją platform, gwarantowane bezpieczeństwo, całodobowa obsługa klienta w zakresie eskorty transakcji",
    myad: {
      title: "Moje ogłoszenie",
      post: "Opublikuj ogłoszenie",
      alert: "【Wskazówka】: Gdy minimalna kwota zakupów reklamowych plus opłata jest większa niż pozostała liczba reklam, reklama jest automatycznie usuwana z półki.",
      no: "NIE",
      type: "typ",
      sell: "sprzedać",
      buy: "kupić",
      limit: "limit",
      remain: "pozostała kwota",
      coin: "moneta",
      created: "data utworzenia",
      operate: "działanie",
      errmsg: "Można edytować i modyfikować po wyłączeniu reklamy",
      update: "redagować",
      shelf: "półka",
      dropoff: "zrzut",
      delete: "usuwać"
    },
    myorder: "Moje zamówienie",
    chatline: {
      status_1: "Kupujący nie zapłacił i czekał, aż kupujący zapłaci!",
      status_2: "Kupujący zapłacił i czeka na zwolnienie sprzedawcy!",
      status_3: "Zamówienie zrealizowane, transakcja!",
      status_4: "Trwa odwołanie od zamówienia!",
      status_5: "Zamówienie anulowane!",
      loadmore: "Załaduj więcej",
      warning: "Alerty zapobiegające oszustwom: W niedawnej przeszłości oszuści wielokrotnie wykorzystywali w celu oszustwa informacje dotyczące przekazów bankowych i fałszywe dane uwierzytelniające przekazy pieniężne, dlatego pamiętaj o sprawdzeniu numeru własnego rachunku płatniczego. Zapewnij bezpieczeństwo przekazów pieniężnych i unikaj ryzyka zamrożenia kart bankowych！",
      contenttip: "Wprowadź treść czatu Wprowadź klawisz, aby wysłać",
      contentmsg: "Wiadomość nie może być pusta"
    },
    chat: {
      seller: "Sprzedający",
      buyer: "Kupujący",
      exchangeamount: "Kwota wymiany",
      operatetip: "Obsługuj końcówkę",
      operatetip_1: "Prosimy o dokonanie płatności zgodnie z kontem podanym przez drugą stronę w wyznaczonym terminie i kliknięcie na tę stronę.",
      finishpayment: "płatność zakończona",
      operatetip_1_1: "Podczas przesyłania proszę podać numer referencyjny prawidłowej płatności w komentarzach",
      operatetip_1_2: "Po otrzymaniu płatności sprzedawca potwierdzi płatność na stronie internetowej. System automatycznie wyśle ​​zakupione zasoby cyfrowe na Twoje konto. Proszę o tym pamiętać",
      note: "Notatka",
      notetip: "Prosimy nie używać innego oprogramowania do czatowania w celu wzajemnej komunikacji i nie przyjmować żadnych dokumentów, załączników do wiadomości e-mail itp. przesyłanych do Państwa zgodnie z instrukcją. Wszystkie łącza komunikacyjne są realizowane w oknie czatu na tej stronie.",
      operatetip_2_1: "Sprzedane zasoby cyfrowe zostały przesłane na platformę w celu hostingu i zamrożenia. potwierdziłeś płatność, kliknij",
      operatetip_2_2: "Nie wierz w żaden powód nalegania na uwolnienie waluty, potwierdź otrzymanie pieniędzy i zwolnij zasoby cyfrowe, aby uniknąć strat!",
      operatetip_2_3: "Po otrzymaniu krótkiej wiadomości dotyczącej konta pamiętaj o zalogowaniu się do bankowości internetowej lub mobilnej, aby potwierdzić, czy płatność została zaksięgowana, aby uniknąć fałszywego uwolnienia zasobów cyfrowych w wyniku otrzymania fałszywych wiadomości!",
      confirmrelease: "Potwierdź wydanie",
      paydigital: "Płać aktywami cyfrowymi",
      orderstatus: "Stan zamówienia",
      orderstatus_1: "płatność zakończona",
      orderstatus_2: "Apelacja o zamówienie",
      orderstatus_3: "Potwierdź wydanie",
      orderstatus_4: "anulować umowę",
      orderstatus_5: "Apelacja o zamówienie",
      order: "Zamówienie",
      and: "I",
      transition: "giełda",
      transprice: "Cena handlowa",
      transnum: "Numer handlowy",
      transmoney: "Kwota handlowa",
      tip1: "Użytkownik nie dodał jeszcze numeru karty bankowej",
      tip2: "Użytkownik na razie nie dodał konta Alipay",
      tip3: "Użytkownik nie dodał jeszcze konta WeChat",
      zfb: "Alipay",
      wx: "WeChat",
      qrcode: "Kod QR",
      msg1: "Czy na pewno zapłaciłeś?",
      msg2: "Płatności nie podlegają zwrotowi! Czy na pewno chcesz anulować swoje zamówienie?",
      msg3: "【Powtórz】: Płatności nie podlegają zwrotowi! Czy na pewno chcesz anulować zamówienie?",
      msg4: "Zapłacono, nie otrzymano",
      msg5: "Już zapłacono, nie otrzymano",
      tip: "Wskazówka",
      comptype: "Rodzaj reklamacji",
      compremark: "Notatka reklamacyjna",
      willcomp: "Chcę złożyć skargę",
      msg6: "Czy potwierdzasz uwolnienie waluty?",
      result_1: "czeka na zapłatę",
      result_2: "Oczekiwanie na wydanie",
      result_3: "Zakończony",
      result_4: "Pociągający",
      result_5: "Odwołany",
      msg7: "Hasło funduszu",
      msg7tip: "proszę podać hasło funduszu"
    },
    checkuser: {
      emaildone: "Certyfikat e-mail",
      emailundo: "Nieautoryzowany e-mail",
      teldone: "Certyfikat Telno",
      telundo: "Telno nieautoryzowane",
      idcarddone: "Certyfikat IDCard",
      idcardundo: "IDCard nieautoryzowany",
      language: "język",
      languagetext: "chiński",
      registtime: "Czas rejestracji",
      exchangetimes: "Skumulowane transakcje",
      exchangeinfo: "Informacje handlowe",
      tablabel1: "Sprzedawaj w Internecie",
      tablabel2: "Kup online",
      col_symbol: "Moneta",
      col_paymode: "Metoda płatności",
      col_num: "Kwota",
      col_price: "Cena",
      col_created: "Czas zwolnienia",
      col_operate: "Działać",
      operatemsg: "Najpierw wykonaj uwierzytelnienie przy użyciu prawdziwego imienia i nazwiska",
      buyin: "Przelicytować",
      sellout: "Wyprzedać"
    },
    tradecenter: {
      postad: "Opublikuj ogłoszenie",
      exchange: "Transakcja GCC",
      buyin: "Chcę się zarejestrować",
      sellout: "Chcę się wyprzedać"
    },
    tradeinfo: {
      emaildone: "Certyfikat e-mail",
      emailundo: "Nieautoryzowany e-mail",
      teldone: "Certyfikat Telno",
      telundo: "Telno nieautoryzowane",
      idcarddone: "Certyfikat IDCard",
      idcardundo: "IDCard nieautoryzowany",
      exchangetimes: "Czasy wymiany",
      price: "Cena",
      num: "Kwota",
      paymethod: "Metoda płatności",
      exchangelimitamount: "Limit wymiany",
      location: "Lokalizacja",
      location_text: "Chiny",
      exchangeperiod: "Okres wymiany",
      minute: "min",
      amounttip: "Proszę wpisać kwotę",
      numtip: "Proszę wpisać numer",
      remarktip: "Przekaż mu swoją prośbę",
      remarktitle: "Uwagi dotyczące horyzontu",
      exchangetitle: "Informacje handlowe",
      exchange_tip1: "Po zainicjowaniu żądania transakcji waluta cyfrowa zostaje zablokowana w hostingu i chroniona przez platformę. Jeśli jesteś sprzedawcą, po zainicjowaniu żądania transakcji możesz doładować konto i poczekać, aż kupujący zapłaci. Kupujący płacą w terminie płatności. Po otrzymaniu płatności powinieneś zwolnić walutę cyfrową, która jest pod twoją opieką.",
      exchange_tip2: "Przed przystąpieniem do handlu przeczytaj 《Warunki korzystania z sieci platform》 oraz często zadawane pytania, przewodniki handlowe i inną dokumentację pomocy.",
      exchange_tip3: "Uwaga na kłamcę! Przed transakcją proszę sprawdzić ocenę otrzymaną przez użytkownika i zwrócić większą uwagę na nowo utworzone konto.",
      exchange_tip4: "Należy pamiętać, że zaokrąglenia i wahania cen mogą mieć wpływ na ilość waluty cyfrowej będącej przedmiotem ostatecznego obrotu. Stała kwota, którą wprowadzisz, określa ostateczną kwotę, a kwota w walucie cyfrowej zostanie obliczona na podstawie aktualnego kursu wymiany obowiązującego w tym samym momencie, w którym złożono żądanie.",
      exchange_tip5: "Usługi hostingowe chronią zarówno kupujących, jak i sprzedających transakcje internetowe. W przypadku sporu ocenimy wszystkie dostarczone informacje i udostępnimy hostowaną walutę cyfrową jej prawnemu właścicielowi.",
      warning1: "Wprowadź maksymalnie 2 miejsca po przecinku",
      warning2: "Kwota zamówienia wynosi",
      warning3: "Wprowadź maksymalnie 8 miejsc po przecinku",
      warning4: "Ilość zamówienia wynosi",
      confirmbuyin: "Potwierdź zakup",
      confirmsellout: "Potwierdź sprzedaż",
      buyin: "Przelicytować",
      sellout: "Wyprzedać",
      warning5: "Proszę wypełnić zamówienie zgodnie z wymaganiami"
    },
    publishad: {
      createad: "Utwórz umowę reklamową",
      msg1: "Jeśli często handlujesz, możesz stworzyć własną reklamę handlową. Jeśli handlujesz tylko sporadycznie, zalecamy bezpośrednie wyszukiwanie",
      msg2: "Utwórz reklamę handlową",
      msg3: "Darmo",
      msg4: "Jeśli chcesz bezpośrednio edytować utworzone reklamy, sprawdź",
      tradead: "Reklama handlowa",
      myad: "Moje ogłoszenie",
      iwant: "Chcę",
      sellonline: "sprzedawaj w Internecie",
      buyonline: "kup w Internecie",
      exchangecoin: "Wymień monetę",
      country: "Kraj",
      currency: "Moneta",
      openfixedprice: "Otwórz stałą cenę",
      open: "Otwarte",
      close: "Zamknąć",
      usetip: "Po włączeniu cena Twojej waluty nie będzie się zmieniać w zależności od rynku i cena nie ulegnie zmianie.",
      premiseprice: "Premia",
      premisepricetip: "Proszę ustawić swoją składkę",
      fixedprice: "stała cena",
      fixedpricetip: "Proszę podać cenę wymiany",
      marketprice: "Rynkowa cena referencyjna",
      marketpricetip: "Premia określa, jaki procent jest wyższy od aktualnej ceny rynkowej",
      exchangeprice: "Cena wymiany",
      formual: "Formuła cenowa",
      num: "Kwota",
      num_text1: "Wpisz, co chcesz",
      num_text2: "liczba",
      exchangeperiod: "Okres transakcji",
      exchangeperiod_text1: "Proszę podać ostateczny termin transakcji",
      minute: "min",
      tip1: "Przez jaki czas kupujący może akceptować transakcje, proszę wpisać liczbę całkowitą",
      tip2: "【Wskazówka】 Można powiązać z centrum osobistym/Dodaj metodę płatności",
      tip3: "Proszę podać minimalną kwotę transakcji",
      tip4: "Proszę podać maksymalną kwotę transakcji",
      tip5: "Możesz wpisać swoje specjalne wymagania w informacjach o uwagach, takich jak: wymagania kupującego, czas online i tak dalej.",
      paymode: "Metoda płatności",
      minlimit: "Minimalna kwota transakcji",
      maxlimit: "Maksymalna kwota transakcji",
      remark: "Uwagi",
      openautoreply: "Otwórz automatyczną odpowiedź",
      msg5: "Po włączeniu tej opcji, gdy użytkownik zainicjuje transakcję za pośrednictwem tej reklamy, system automatycznie wyśle ​​drugą stronę wybraną przez Ciebie frazę automatycznej odpowiedzi.",
      autoreply: "Automatyczna odpowiedź",
      autoreplytip: "Po otrzymaniu zamówienia automatycznie zwracane są kupującemu informacje, np.: sposób płatności, numer rachunku odbiorczego itp.",
      fundpwd: "Hasło funduszu",
      fundpwdtip: "Proszę podać hasło do środków",
      submit: "Składać",
      warning1: "Proszę wpisać poprawny numer",
      warning2: "Wartość przepełnienia wynosi 0-20",
      warning3: "Proszę podać maksymalną kwotę transakcji!",
      warning4: "Proszę wprowadzić liczbę całkowitą",
      warning5: "Maksymalna kwota transakcji musi być większa niż minimalna kwota transakcji!",
      warning6: "Maksymalna kwota transakcji nie może przekroczyć całkowitej kwoty sprzedaży",
      warning7: "Proszę podać minimalną kwotę transakcji!",
      warning8: "Minimalna kwota transakcji musi być większa lub równa 100!",
      warning9: "Minimalna kwota transakcji musi być mniejsza niż maksymalna kwota transakcji",
      sellout: "Sprzedać",
      buyin: "Kupić",
      inputtip1: "Proszę wprowadzić walutę",
      inputtip2: "Proszę wprowadzić poprawną opcję",
      inputtip3: "Wartość przepełnienia wynosi 0–20 i nie może wynosić 0",
      inputtip4: "Proszę wprowadzić poprawną stałą cenę",
      inputtip5: "Proszę wpisać poprawną liczbę, a maksymalna ilość transakcji nie przekracza 100",
      inputtip6: "Proszę podać poprawny termin transakcji",
      inputtip7: "Proszę wybrać metodę transakcji",
      inputtip8: "Proszę wprowadzić hasło do środków",
      zfb: "Alipay",
      wx: "Wechat",
      unionpay: "UnionPay",
      submit_failure: "Awaria!",
      submittip1: "Proszę kontynuować serię certyfikatów, takich jak prawdziwe nazwiska",
      submittip2: "Prosimy o przeprowadzenie szeregu zaświadczeń np. o telefony komórkowe",
      submittip3: "Kontynuuj, stosując szereg certyfikatów, takich jak hasła kapitałowe",
      submittip4: "Proszę powiązać przynajmniej jedną metodę płatności"
    },
    index: {
      title: "Dobra rekomendacja reklamowa",
      exchangetimes: "Czasy transakcji",
      exchangeprice: "Cena transakcyjna",
      exchangelimit: "Limit transakcji",
      paymode: "Metoda płatności",
      buy: "kupić",
      sell: "sprzedać",
      viewmore: "Więcej",
      bot1: "Bezpieczny i niezawodny",
      bot1_tip: "Ponad 10 lat doświadczenia w zespole kontroli ryzyka finansowego\nKonfigurowalny system polityki bezpieczeństwa",
      bot2: "Szybkie i łatwe",
      bot2_tip: "Obsługa bezpłatnego trybu transakcji peer-to-peer\nRodzaje kanałów wymiany pieniędzy",
      bot3: "Pełna waluta",
      bot3_tip: "Wybór głównych walut transakcji na aktywach cyfrowych\nDoświadczenie w handlu wieloma aktywami",
      ibuy: "Chcę kupić",
      isell: "Chcę sprzedać"
    }
  },
  activity: {
    all: "Wszystko",
    prepare: "Nadchodzący",
    ongoing: "Bieżący",
    distributing: "Rozdzielczy",
    completed: "Zakończony",
    progress: "Postęp",
    totalsupply: "Całkowita podaż",
    starttime: "Data rozpoczęcia",
    endtime: "Data zakończenia",
    viewdetail: "Szczegół",
    attend: "Brać udział",
    tokendistribute: "Dystrybucja tokenów",
    baseinfo: "Informacje o aktywności",
    status: "Status",
    activitytype: "Typ działania",
    activitytype0: "Nieznany",
    activitytype1: "Lista (FOF)",
    activitytype2: "Lista (AVA)",
    activitytype3: "UchwytPodziel",
    activitytype4: "Bezpłatny zakup",
    activitytype5: "GórnictwoKup",
    activitytype6: "Zamknięty",
    ruledetail: "O zasadzie",
    publishprice: "Opublikuj cenę",
    activitycoin: "Symbol monety aktywności",
    accpetcoin: "Zaakceptuj symbol monety",
    holdcoin: "Przytrzymaj symbol monety",
    limittimes: "Limity osobiste",
    limitamount: "Kwota limitu osobistego",
    unlimited: "Nieograniczony",
    alreadyamount: "Sprzedaj już kwotę",
    leftamount: "Pozostała kwota",
    attention: "Uwaga",
    attentiontxt1: "1. Aktywa zostaną zamrożone po zgłoszeniu udziału w działaniach typu [podział magazynu] i [bezpłatna subskrypcja] do czasu zakończenia rozmrażania.",
    attentiontxt2: "2. Użytkownicy nie mogą wycofać swojego wniosku o uczestnictwo po wzięciu udziału w działaniach typu „Holder Divide” i „Fress Buy”",
    attentiontxt3: "3、Jeżeli działanie zostanie anulowane z powodu strony projektu i innych czynników siły wyższej, pierwotna trasa zostanie zwrócona do zamrożonych aktywów.",
    attentiontxt4: "*Prawo do ostatecznej interpretacji tej działalności należy do oficjalnej własności BIPPAX.",
    inputamount: "Kwota wejściowa",
    inputholdamount: "Wartość blokady wejściowej",
    mybalance: "Dostępne saldo",
    holdtips: "[HolderDivide] wymaga blokady do końca działania.",
    pleaseinputamount: "Proszę wpisać kwotę!",
    pleaseinputholdamount: "Proszę wprowadzić kwotę wstrzymania!",
    commitfailed: "Zatwierdzenie nie powiodło się!",
    minlimitamountfailed: "Ilość wymiany nie może być mniejsza niż minimalna minimalna kwota wymiany.！",
    maxlimitamountfailed: "Kwota wymiany nie może być większa niż maksymalna kwota zakupu.！",
    limittimesfailed: "Brałeś udział w większej liczbie pojedynczych zakupów niż maksymalna.！",
    balancenotenough: "Równowaga nie wystarczy!",
    headertitledesc: "Otwarte laboratoria dla korzystnej dla obu stron współpracy pomiędzy inwestorami, projektorami i giełdami",
    currentdivided: "Otrzymam moją obecną pozycję",
    leveloneCount: "Limit poziomu pierwszego",
    submit: "Składać",
    tipsmobile: "Skorzystaj z Internetu na komputerze （www.BIPPAX.com）",
    tipsmobile1: "Aby wziąć udział w tym ćwiczeniu, możesz wejść do sieci komputerowej.",
    intvalue: "Proszę wprowadzić wartość int",
    inputminingamount: "Wprowadź liczbę zakupów",
    moreactivity: "Więcej zajęć",
    releaseType: "Typ wydania",
    releaseType0: "Równe uwolnienie",
    releaseType1: "Zwolnienie izometryczne",
    lock: "Zamek",
    releaseDetail: "Szczegóły wydania",
    lockday: "Dni",
    lockweek: "Tygodnie",
    lockmonth: "Miesiące",
    lockyear: "Lata",
    releasePercent: "Procent zwolnienia",
    lockFee: "Opłata za zamek",
    releaseTimes: "Czasy wydania",
    times: "czasy"
  },
  invite: {
    myinvitelink: "Link promocyjny",
    copy: "Kopia",
    copyed: "Skopiowano",
    mylevelone: "Przyjaciele pierwszego poziomu",
    myleveltwo: "Przyjaciele z poziomu drugiego",
    mycommission: "Dochód z prowizji (USDT)",
    extrareward: "Dodatkowe nagrody",
    partnerlevel: "Poziom partnerstwa",
    ruledetail: "Szczegóły reguły",
    ruleprofile1: "[Partner Promocji] to najwyższy odsetek zwrotu prowizji online i najdłuższy czas zwrotu prowizji (maksymalna prowizja w całym okresie). Promotorzy, którzy dołożą odpowiednich starań, mogą stać się prawdziwymi „partnerami” platformy i cieszyć się korzyściami płynącymi z wspólnego rozwoju z platformą transakcyjną BIPPAX. Szczegółowe zasady przedstawiają się następująco:",
    ruleprofile2: "",
    ruleprofile3: "",
    ruleprofile4: "",
    ruletext1: "1、W celu propagowania koncepcji zasobów cyfrowych i poszerzania skali użytkowników, BIPPAX uruchomił program „Partner Promocji”, który działa od dawna.",
    ruletext2: "2. Zapraszanie znajomych można podzielić na dwa poziomy. Jeśli A zaprasza B, to B jest przyjacielem A na pierwszym poziomie. Jeśli B zaprasza C, wówczas C należy do przyjaciela B z pierwszego poziomu, a także do przyjaciela z drugiego poziomu A.",
    ruletext3: "3. Promując rejestrację znajomych, znajomi pierwszego poziomu osób zapraszających mogą być znajomymi pierwszego poziomu osób zapraszających za pomocą linków dostarczonych przez osoby zapraszające lub poprzez ręczne wprowadzenie kodów zaproszeń osób zapraszających.",
    ruletext4: "4、Gdy osoba zaproszona zarejestruje się przy użyciu kodu zaproszenia zapraszającego i ukończy proces certyfikacji prawdziwego imienia i nazwiska, zachęta Komisji zacznie obowiązywać.",
    ruletext5: "5、Czas prowizji wynosi N miesięcy od rozpoczęcia certyfikacji prawdziwego imienia i nazwiska osoby zaproszonej. W zależności od różnych stopni proporcja pobieranej prowizji jest różna.",
    ruletext6: "6. Promocja aktywów prowizyjnych to opłata transakcyjna waluty przyjaciela niższego poziomu, czyli trzech walut bazowych rynku, a mianowicie USDT, BTC i ETH.",
    ruletext7: "7. Proporcje i czas trwania prowizji za promocję są dodatnio skorelowane z liczbą znajomych pierwszego poziomu. Im większa liczba promocji, tym wyższy odsetek przyjemnej prowizji. Konkretna promocja współczynnika rabatu prowizji jest następująca:",
    ruletext8: "8. TOP10 lub TOP100 będą od czasu do czasu nagradzane przez MKWORLDS dodatkowymi nagrodami.",
    ruletext9: "9. Jeśli inne działania kolidują z działaniami Partnera ds. promocji, po konsultacji oczekuje się, że Partnerzy zrozumieją, czy należy dokonać tymczasowej zmiany.",
    ruletext10: "10. Partnerzy na poziomie wysłannika L4(Xunfu), L5(Taishou) i L6(Jiedushi) są uprawnieni odpowiednio do premii w wysokości 5%, 10% i 15% całkowitego rocznego zwrotu prowizji.",
    ruletext11: "11. Prawo ostatecznej interpretacji tej czynności należy do BIPPAX.",
    ruleexampletitle: "Na przykład:",
    ruleexamplecontent1: "Jeśli użytkownik Xiaoyan zaprosił 100 znajomych pierwszej klasy, znajomi TA pierwszej klasy zaprosili pięciu znajomych drugiej klasy, to Xiaoyan miał 100 znajomych pierwszej klasy i 500 znajomych drugiej klasy. Jeśli przeciętna osoba handluje 3000 juanów dziennie, miesięczny dochód Xiaoyan wynosi około (100 * 3000 * 0,001 * 30% + 500 * 3000 * 0,001 * 10%)* 30 = 7200 / miesiąc.",
    ruleexamplecontent2: "Jeśli użytkownik Xiaoyan zaprosił 1000 znajomych pierwszej klasy, znajomi TA pierwszej klasy zaprosili 5 znajomych drugiej klasy, Xiaoyan miał 1000 znajomych pierwszej klasy i 5000 znajomych drugiej klasy. Jeśli przeciętna osoba handluje 3000 juanów dziennie, miesięczny dochód Xiaoyan wynosi około (1000*3000*0,001*50%+5000*3000*0,001*20%)*30=135000/miesiąc.",
    lastupdate: "Ostatnia aktualizacja w",
    laststastic: "Ostatnia statystyka w",
    level: "Poziom",
    lv1: "Lizhenga",
    lv2: "Xianling",
    lv3: "Żyfu",
    lv4: "Xunfu",
    lv5: "Taishou",
    lv6: "Jiedushi",
    levelonecount: "Numer pierwszego poziomu",
    levelonecommission: "Wskaźnik zwrotu/czas zwrotu pierwszego poziomu",
    leveltwocommission: "Poziom drugi Wskaźnik zwrotu/czas zwrotu",
    partnerdivide: "Dywidenda partnerska",
    month: "Miesiące",
    alllife: "Życie",
    totalcommissionrank: "Promocja całkowitej prowizji",
    rank: "NIE.",
    userid: "Identyfikator użytkownika",
    rankday: "(Dzień)",
    rankweek: "(Tydzień)",
    rankmonth: "(Miesiąc)",
    rankall: "(Wszystko)",
    promotioncount: "Liczba promocji",
    commissionusdt: "Prowizja (USDT)",
    ranktip1: "Liczba zaproszeń to liczba pierwszorzędnych przyjaciół. Na tej liście łączna kwota prowizji jest uporządkowana od dużych do małych.",
    ranktip2: "Liczba zaproszeń to liczba pierwszorzędnych przyjaciół. Lista jest uszeregowana według liczby zaproszonych znajomych pierwszej klasy.",
    thanks: "Dziękujemy za wsparcie BIPPAX!",
    headertip: "Powyższe dane nie są aktualizowane w czasie rzeczywistym. Statystyki systemu i aktualizacje są co 24 godziny.",
    ptools: "Narzędzia promocyjne",
    pt_title: "Karta Podarunkowa Kryptowaluty",
    pt_desc: "To niespodzianka z przyszłości, którą możemy wysłać przyjaciołom, krewnym, klientom, partnerom.",
    pt_more: "Nadchodzi więcej narzędzi",
    pt_tips: "Jeśli masz dobry pomysł, wyślij e-mail na adres Promotion@BIPPAX.com, a po adopcji otrzymasz nagrodę!",
    pt_card_amount: "Kwota karty",
    pt_card_deadline: "Termin ostateczny",
    pt_card_noend: "Nieokreślony",
    pt_card_btn: "Zdobądź 30 kart za darmo (≈2000 CNY)",
    pt_card_btn_login: "Proszę się najpierw zalogować",
    pt_card_rule: "Szczegóły reguły",
    pt_card_summary: "Karta podarunkowa w walucie cyfrowej to narzędzie promocyjne opracowane, aby umożliwić partnerom promocyjnym lepsze zapraszanie znajomych offline. Kiedy użytkownicy wymieniają karty upominkowe, automatycznie stają się znajomymi offline partnerów promocyjnych.",
    pt_card_rule1: "1. Liczba bezpłatnych kart podarunkowych ograniczona jest do 30 kart na użytkownika. Jeśli trzeba wydać więcej kart podarunkowych, użytkownicy muszą zapłacić za personalizację, która może dostosować liczbę kart, LOGO, instrukcje itp. W przypadku niestandardowych wymagań wyślij e-mail na adres",
    pt_card_rule2: "2. Bezpłatne karty podarunkowe są ograniczone do jednego egzemplarza na użytkownika. Bezpłatne karty podarunkowe wydawane przez rząd BIPPAX są ograniczone do jednej na każdego użytkownika. Nawet jeśli różni użytkownicy otrzymają bezpłatne karty podarunkowe z różnymi kodami wymiany, tylko jedna może zostać wymieniona. Niestandardowe karty upominkowe nie podlegają temu ograniczeniu.",
    pt_card_rule3: "3. Przed wymianą karty podarunkowej przez użytkownika, jeśli nie ma „zapraszającego” (tzn. w momencie rejestracji konta nie został wpisany kod zaproszenia), zostanie ona automatycznie powiązana z przyjacielem pierwszego stopnia wystawcy karty. Jeśli A nie wprowadzi kodu zaproszenia podczas rejestracji konta, wówczas A nie należy do żadnego znajomego pierwszego lub drugiego poziomu, ale kiedy A zostanie przekształcony w znajomych pierwszego poziomu B poprzez kartę podarunkową wydaną przez B, A automatycznie stanie się znajomym pierwszego poziomu B.",
    pt_card_rule4: "4. Aby zapobiec szczotkowaniu, wartość księgowa kart podarunkowych nie jest wypłacana w czasie rzeczywistym. Zostanie on zamrożony na 180 dni od momentu pobrania i automatycznie dodany do salda konta użytkownika po 180 dniach.",
    pt_card_rule5: "5. Otrzymując bezpłatne karty podarunkowe, musimy wypełnić certyfikat prawdziwego imienia i nazwiska. Konwertując możemy je uzyskać bez konieczności wypełniania zaświadczenia na prawdziwe nazwisko. Ma to na celu ułatwienie promotorom szybszego zdobywania znajomych na niższym poziomie.",
    pt_card_rule6: "6. Prawo ostatecznej interpretacji bezpłatnych kart podarunkowych przysługuje BIPPAX.PRO.",
    pt_card_day: "Dni",
    pt_card_title_tips: "Bezpłatny grant promocyjny w wysokości 2000 CNY",
    pt_card_receivew_success: "Gratulacje! Udana kolekcja kart podarunkowych promocji partnerskiej! Przejdź do Centrum Personalnego -> Centrum Kart i Voucherów.",
    usepromotion: "Korzystaj z materiałów promocyjnych",
    saveimage: "Zapisz obraz",
    imagetips: "Jeśli nie możesz poprawnie pobrać zdjęć, pobierz je za pomocą narzędzia do zrzutów ekranu!",
    pt_invite_title: "Ulotka rejestracyjna z zaproszeniem",
    pt_invite_desc: "Automatycznie stań się podwładnymi przyjaciółmi poprzez rejestrację dwuwymiarowego kodu, odpowiedniego do przekazywania w różnych grupach lub forach.",
    colum_text0: "Stopień",
    colum_text1: "Członek",
    colum_text2: "Promocja",
    colum_text3: "Prowizja (USDT)",
    colum_text4: "Dodatkowa nagroda",
    context_title: "Ekskluzywny kod realizacji dla partnerów promocyjnych",
    context_title1: "Zeskanuj, aby dowiedzieć się więcej",
    context_title2: "Mój kod zaproszeniowy",
    context_title3: "Obraz zaproszenia"
  },
  uc: {
    verify: "Najpierw ukończ KYC",
    login: {
      noaccount: "Brak konta?",
      register: "Zapisać się",
      login: "Zaloguj się",
      welcomelogin: "Powitanie",
      usertip: "Proszę wpisać e-mail",
      pwdtip: "Wprowadź hasło",
      validatecodeload: "Ładowanie kodu weryfikacyjnego",
      validatemsg: "Najpierw dokończ weryfikację",
      forget: "Nie pamiętasz hasła?",
      loginvalidate: "Proszę podać e-mail lub numer telefonu",
      pwdvalidate1: "Proszę wprowadzić hasło",
      pwdvalidate2: "Długość hasła nie mniejsza niż sześć",
      success: "Sukces",
      goregister: "Aby się zarejestrować",
      getlostpwd: "Zapomnij hasło"
    },
    forget: {
      title: "Znajdź hasło",
      hasaccount: "Masz konto? Aby się zalogować",
      login: "Zaloguj się",
      sendcode: "Wysłać",
      newpwd: "Wprowadź nowe hasło",
      confirmpwd: "Wprowadź ponownie nowe hasło",
      save: "Składać",
      pwdvalidate1: "Wprowadź potwierdzenie hasła",
      pwdvalidate2: "Hasło nie jest takie samo!",
      resettelpwd: "Zresetuj hasło tel",
      resetemailpwd: "Zresetuj hasło e-mail",
      newpwdtip: "Wprowadź nowe hasło",
      pwdvalidate3: "Długość hasła nie mniejsza niż sześć",
      telno: "Numer telefonu",
      mtelno: "Uwierzytelnianie telefonu komórkowego",
      memail: "Uwierzytelnianie skrzynki pocztowej",
      smscode: "Kod weryfikacyjny SMS-em",
      teltip: "Wpisz tel",
      smscodetip: "Wpisz SMS-owy kod weryfikacyjny",
      email: "E-mail",
      emailcode: "Kod weryfikacyjny e-mail",
      emailtip: "Wpisz adres e-mail",
      emailcodetip: "Wprowadź kod weryfikacyjny e-mail",
      resetpwdsuccess: "Resetowanie hasła powiodło się",
      smswarn: "Proszę sprawdzić SMS-y"
    },
    finance: {
      fi1: "Verstecke kleine Vermögenswerte",
      center: "Centrum finansowe",
      personalassets: "Aktywa walutowe",
      swapassets: "Zamień aktywa",
      billdetail: "Szczegóły rachunku",
      charge: "Depozyt",
      pickup: "Wycofanie",
      tradetail: "Górnictwo Handlowe",
      paydividends: "Wypłacaj dywidendy",
      invitingmining: "Zapraszanie nagród górniczych",
      money: {
        M1: "Otrzymana ilość",
        M2: "Przenieś ilość",
        M3: "Kurs wymiany",
        cointype: "Moneta",
        balance: "Balansować",
        frozen: "Zamrożona równowaga",
        operate: "Działanie",
        charge: "Depozyt",
        pickup: "Wycofanie",
        onkeytrans: "Przeł",
        getaddress: "Uzyskaj adres",
        resetsuccess: "Zresetuj sukces",
        match: "Mecz",
        matchtip1: "Dostępna dopasowana kwota GCX",
        matchtip2: "Wprowadź kwotę dopasowania",
        matcherr1: "Proszę podać prawidłową ilość!",
        matcherr2: "Przekracza maksymalną liczbę dopasowań!",
        matchsuccess: "Sukces meczu!",
        needreleased: "Majątek do wydania",
        totalassets: "Szacunkowa łączna wartość aktywów:"
      },
      swap: {
        totalassets: "Szacunkowa łączna wartość aktywów:",
        swap: "Zamieniać",
        swaptype: "ZAMIENIAĆ",
        swapassets: "Kapitał konta",
        avabalance: "Dostępny margines",
        usebalance: "Używany margines",
        frozenbalance: "Zamrożony margines",
        profitandloss: "Niezrealizowany pl",
        transfor: "Przenosić",
        inputtransferamount: "Kwota przelewu",
        all: "Wszystko",
        currencyaccount: "Konto spotowe",
        swapaccount: "Konto bezterminowej wymiany",
        clickchange: "Kliknij, aby zmienić kierunek",
        avaamount: "Dostępne",
        pleaseselectwallet: "Proszę wybrać pięść portfela transferowego.",
        pleaseinputamount: "Proszę wprowadzić kwotę przelewu",
        oktransfer: "Przenieś teraz"
      },
      trade: {
        start_end: "Początek-Koniec",
        account_date: "Czas na zdobycie kapitału",
        to: "Do",
        operatetype: "Typ akcji",
        search: "Szukaj",
        charge: "Opłata",
        pickup: "Ulec poprawie",
        transaccount: "Przenosić",
        exchange: "Giełda",
        otcbuy: "Kup OTC",
        otcsell: "Sprzedaż OTC",
        activityaward: "Nagroda za aktywność",
        promotionaward: "Nagroda promocyjna",
        dividend: "Dywidenda",
        vote: "Głosować",
        handrecharge: "Sztuczne ładowanie",
        match: "Mecz",
        activitybuy: "Aktywność Kup",
        ctcbuy: "CTC-Kup",
        ctcsell: "CTC-Sprzedaj",
        chargetime: "czas generowania zamówienia",
        type: "Typ",
        num: "Kwota",
        status: "Status",
        finish: "Gotowy",
        fee: "Zwrot opłat eksploatacyjnych",
        transactionTime: "Czas handlu",
        symbol: "Para monet",
        direction: "Kierunek",
        price: "Cena",
        entrustment: "Powierzenie",
        havedeal: "Zawarłem umowę",
        poundageAmount: "Koszt obsługi",
        exchangeOrderId: "Identyfikator zamówienia",
        mineAmount: "Wykop walutę (BHB)",
        buy: "KUPIĆ",
        sell: "SPRZEDAĆ",
        limit: "LIMIT",
        market: "RYNEK",
        clear: "Stan jasny",
        turnover: "Obrót"
      },
      paydividende: {
        money_holding: "Dzielenie się pieniędzmi zostało zwrócone i zgromadzone (ETH):",
        money_hold: "Wypłacaj dywidendy w zamian za zwrot (ETH):",
        paydividends: "Wypłacaj dywidendy (ETH)",
        account_date: "Czas na zdobycie kapitału",
        datehodld: "Data przechowywania pieniędzy",
        start_end: "Początek-Koniec",
        to: "Do",
        operatetype: "Typ akcji",
        search: "Szukaj",
        charge: "Opłata",
        pickup: "Ulec poprawie",
        transaccount: "Przenosić",
        exchange: "Giełda",
        otcbuy: "Kup OTC",
        otcsell: "Sprzedaż OTC",
        activityaward: "Nagroda za aktywność",
        promotionaward: "Nagroda promocyjna",
        dividend: "Dywidenda",
        vote: "Głosować",
        handrecharge: "Sztuczne ładowanie",
        match: "Mecz",
        chargetime: "Czas ładowania",
        type: "Typ",
        num: "Kwota",
        status: "Status",
        finish: "Gotowy",
        fee: "Opłata",
        symbol: "Symbol monety"
      },
      record: {
        Please: "Proszę wybrać zakres dat wyszukiwania",
        start_end: "Początek-Koniec",
        to: "Do",
        operatetype: "Typ akcji",
        search: "Szukaj",
        charge: "Opłata",
        pickup: "Ulec poprawie",
        transaccount: "Przenosić",
        exchange: "Giełda",
        otcbuy: "Kup OTC",
        otcsell: "Sprzedaż OTC",
        activityaward: "Nagroda za aktywność",
        promotionaward: "Nagroda promocyjna",
        dividend: "Dywidenda",
        vote: "Głosować",
        handrecharge: "Sztuczne ładowanie",
        match: "Mecz",
        chargetime: "Czas ładowania",
        type: "Typ",
        num: "Kwota",
        status: "Status",
        finish: "Gotowy",
        fee: "Opłata",
        shouldfee: "Opłata płatna",
        revenue: "Rodzaj przychodów i wydatków",
        re1: "Eingang",
        re2: "Ausganga",
        discountfee: "Opłata za potrącenie",
        realfee: "Koszt obsługi",
        symbol: "Symbol monety",
        activitybuy: "Aktywność Kup",
        ctcbuy: "C2C KUP",
        ctcsell: "SPRZEDAM C2C",
        redout: "RED-OUT",
        redin: "CZERWONE",
        quickExchange: "Szybka wymiana",
        currentRate: "Aktualny kurs wymiany",
        from: "Z",
        inputexchangeamount: "Wprowadź kwotę szybkiej wymiany",
        inputexchangepasswd: "Wprowadź hasło wymiany",
        chooseTransCoinUnit: "Wybierz monetę Trans",
        inputTransAmount: "Wybierz kwotę transakcji",
        predictAmount: "Wymienię",
        qamount: "Ilość",
        qrate: "Wskaźnik",
        qexamount: "Kwota wymiany",
        withdrawcodein: "Doładowanie kodu wypłaty",
        withdrawcodeout: "WypłataKod wypłaty",
        contractfee: "Opłata za zamianę",
        contractprofit: "Zamień zysk",
        contractloss: "Strata zamiany",
        optionfail: "Opcja nieudana",
        optionfee: "Opłata za opcję",
        optionreward: "Nagroda za opcję",
        other: "Inny"
      },
      recharge: {
        recharge: "Depozyt",
        symbol: "Moneta",
        address: "Adres depozytu",
        copy: "Kopia",
        qrcode: "Kod QR",
        qrcodeaddress: "Kod QR dla depozytu",
        msg1: "Nie doładowuj żadnych aktywów bezwalutowych na powyższy adres, w przeciwnym razie aktywa nie zostaną odzyskane.",
        msg2: "Po doładowaniu na powyższy adres należy potwierdzić cały węzeł sieci, po nadejściu 2 potwierdzeń sieci, po 6 potwierdzeniach sieci można wyodrębnić.",
        msg3: "Minimalna kwota doładowania:",
        msgtop: "Ten adres służy wyłącznie do doładowania",
        msg3_1: ", doładowanie mniejsze niż kwota minimalna nie zostanie naliczone.",
        msg4: "Twój adres doładowania nie będzie się często zmieniał i możesz powtórzyć doładowanie; jeśli nastąpi jakakolwiek zmiana, postaramy się powiadomić Cię za pośrednictwem ogłoszenia na stronie internetowej lub e-maila.",
        msg5: "Pamiętaj, aby potwierdzić bezpieczeństwo swojego komputera i przeglądarki, aby zapobiec fałszowaniu lub wyciekowi informacji.",
        record: "Nagranie",
        copysuccess: "Sukces!",
        copyerr: "Awaria! Skopiuj go ręcznie",
        time: "Czas przybycia",
        amount: "Kwota",
        gettingaddress: "Pobieram adres wpłaty. Proszę czekać...",
        getaddress: "Uzyskaj adres depozytu",
        memotips: "Wprowadź tę notatkę podczas ładowania, w przeciwnym razie utracisz aktywa.",
        withdrawrecharge: "Doładuj kodem",
        coderechargetip: "Proszę wprowadzić kod wypłaty",
        rechargesuccess: "Gratulacje, sukces ładowania!",
        rechargeconfirm: "Doładowanie Potwierdź",
        status: "Status"
      },
      withdraw: {
        pickup: "Ulec poprawie",
        addressmanager: "Zarządzanie adresami",
        withdrawbycode: "Wypłata za pomocą kodu",
        withdrawcode: "Wycofaj kod",
        symbol: "Moneta",
        address: "Adres",
        num: "Kwota",
        avabalance: "Dostępne saldo",
        msg1: "Ilość monet jest mniejsza niż",
        msg2: "Automatycznie dociera do konta, w przeciwnym razie wymagane jest ręczne sprawdzenie",
        increase: "Zwiększ kredyt",
        tip1: "Wpisz do",
        tip11: "miejsc po przecinku, a minimalna wartość to",
        tip2: "Maksymalna wartość to",
        numtip1: "Wprowadź liczbę monet",
        fee: "Opłaty",
        range: "Zakres",
        arriamount: "Liczba przyjazdów",
        msg3: "Minimalna liczba monet to",
        msg4: "waluta",
        msg5: "Aby zapewnić bezpieczeństwo środków, w przypadku zmiany polityki bezpieczeństwa Twojego konta, zmiany haseł i korzystania z nowego adresu do wypłaty monet, przeprowadzimy ręczny audyt monet. Prosimy o cierpliwość i oczekiwanie, aż personel zadzwoni lub napisze e-mail.",
        msg6: "Pamiętaj, aby potwierdzić bezpieczeństwo swojego komputera i przeglądarki, aby zapobiec fałszowaniu lub wyciekowi informacji.",
        record: "Rekord wypłat",
        symboltip: "Proszę wybrać walutę",
        addresstip: "Proszę wpisać adres",
        numtip2: "Proszę podać poprawną liczbę monet, minimalna wartość to",
        numtip3: "Kwota monet nie może być mniejsza niż opłata manipulacyjna",
        amounttip: "Proszę wpisać kwotę",
        feetip1: "Minimalna opłata wynosi",
        feetip2: "Maksymalna wartość to",
        time: "Czas wypłaty",
        status: "Status",
        status_1: "Przeglądanie",
        status_2: "Przenoszenie",
        status_3: "Awaria",
        status_4: "Sukces",
        St5: "Szacowany silny parytet",
        St6: "Aktywa ogółem = saldo w portfelu + niezrealizowane",
        St7: "Niezrealizowane zyski i straty=Niezrealizowane zyski i straty obliczone przy użyciu najnowszej ceny dla wszystkich kontraktów holdingowych",
        St8: "Saldo portfela=wpłata - wypłata - zrealizowane zyski i straty",
        St9: "Odrzucony",
        remark: "Uwaga",
        add: "Dodać",
        addresslist: "Lista adresów",
        safevalidate: "Weryfikacja bezpieczeństwa",
        telno: "Tel",
        mtelno: "Uwierzytelnianie telefonu komórkowego",
        memail: "Uwierzytelnianie skrzynki pocztowej",
        smscode: "Kod weryfikacyjny telefonu",
        second: "drugi",
        clickget: "Dostawać",
        email: "E-mail",
        emailcode: "Kod weryfikacyjny e-mail",
        save: "Ratować",
        delete: "Usuwać",
        telerr: "Nieprawidłowy numer telefonu",
        emailerr: "Nieprawidłowy adres e-mail",
        codeerr: "Nieprawidłowy kod weryfikacyjny",
        remarktip: "Wpisz uwagę",
        savemsg1: "Nie udało się zapisać!",
        savemsg2: "Zapisano pomyślnie!",
        operate: "Działać",
        fundpwdtip: "Proszę wprowadzić hasło do środków",
        click: "trzask",
        filtrate: "może filtrować",
        txid: "TxId",
        generateCode: "Wygeneruj kod wypłaty",
        withdrawcodelist: "Lista kodów wypłat",
        withdrawcodestatus: "Status",
        submit: "Składać",
        generatecodesuccess: "Wygenerowano kod wypłaty!",
        wi1: "Sieć",
        wi2: "Uwierzytelnianie bezpieczeństwa",
        wi3: "Otrzymana kwota",
        wi4: "Adres odbioru",
        wi5: "Sieć wypłat",
        wi6: "Całkowita kwota wypłaty",
        wi7: "Opłata sieciowa",
        wi8: "Upewnij się, że podałeś prawidłowy adres wypłaty i że wybrana sieć wypłat jest zgodna z adresem",
        wi9: "Zleceń wypłaty nie można anulować po utworzeniu",
        wi10: "Kontynuować",
        wi11: "Hasło funduszy",
        wi12: "mobilny kod weryfikacyjny",
        wi13: "Wysłać",
        wi14: "Kod",
        wi15: "Wysłać",
        wi16: "Składać"
      }
    },
    member: {
      usercenter: "Profil użytkownika",
      securitycenter: "Centrum bezpieczeństwa",
      securitysetting: "Ustawienie zabezpieczeń",
      accountsetting: "Ustawienie konta",
      account: "Konto",
      assets: "Finanse",
      exchange: "Giełda",
      curdelegate: "Obecny Delegat",
      hisdelegate: "Delegat Historii",
      otc: "OTC"
    },
    order: {
      ordercenter: "Centrum zamówień",
      myorder: "Moje zamówienie",
      myad: "Moja reklama"
    },
    regist: {
      Res1: "Nazwa użytkownika składa się z wielkich i małych liter oraz cyfr i musi zawierać litery",
      hasaccount: "Masz konto? Aby się zalogować",
      login: "Zaloguj się",
      username: "Nazwa użytkownika",
      country: "Kraj",
      smscode: "Kod weryfikacyjny SMS-em",
      sendcode: "Wysłać",
      resendcode: "Wyślij ponownie(",
      pwd: "Hasło",
      repwd: "Potwierdź hasło",
      confrimpwd: "Potwierdź hasło",
      agreement: "Przeczytałem i zgadzam się",
      userprotocol: "Umowa użytkownika",
      regist: "Zapisać się",
      teltip: "Wpisz tel",
      telerr: "Błąd formatu telefonu, wprowadź ponownie",
      emailtip: "Wpisz adres e-mail",
      emailerr: "Błąd formatu wiadomości e-mail. Wprowadź ponownie",
      confirmpwdtip: "Wprowadź potwierdzenie hasła",
      confirmpwderr: "Dwa różne hasła!",
      telregist: "Rejestracja tel",
      emailregist: "Rejestracja e-mailowa",
      usernametip: "Wpisz nazwę użytkownika",
      usernamemsg: "Długość nazwy użytkownika nie mniejsza niż 3, nie większa niż 15",
      countrytip: "Wybierz kraj",
      smscodetip: "Wpisz SMS-owy kod weryfikacyjny",
      pwdtip: "Wprowadź hasło logowania",
      pwdmsg: "Długość hasła nie mniejsza niż 6",
      telno: "Tel",
      email: "E-mail",
      agreementtip: "Kliknij, aby się zgodzić",
      modaltitle: "Proszę o weryfikację",
      promotion: "Kod zaproszenia",
      china: "Chiny",
      singapore: "Singapur",
      korea: "Korea",
      japan: "Japonia",
      thailand: "Tajlandia",
      russia: "Rosja",
      uk: "Wielka Brytania",
      vietnam: "Wietnam",
      india: "Indie",
      italy: "Włochy",
      hk: "hk",
      malaysia: "Malezja",
      taiwan: "Tajwan",
      turkey: "indyk",
      germany: "Niemcy",
      france: "Francja",
      spain: "Hiszpania",
      us: "amerykański"
    },
    safe: {
      beneficiaryTitle: "Informacje o beneficjentach",
      beneficiaryEmpty: "Brak danych beneficjenta",
      beneficiaryName: "Nazwa beneficjenta",
      beneficiaryIdNumber: "Numer identyfikacyjny beneficjenta",
      beneficiaryMobilePhone: "Telefon komórkowy beneficjenta",
      beneficiaryNamePlaceholder: "Proszę wpisać nazwę beneficjenta",
      beneficiaryIdPlaceholder: "Proszę podać numer identyfikacyjny beneficjenta",
      beneficiaryMobilePlaceholder: "Proszę podać telefon komórkowy beneficjenta",
      beneficiaryTip: "Służy do rejestracji i aktualizacji nazwy beneficjenta, numeru identyfikacyjnego i telefonu komórkowego.",
      beneficiaryNameRequired: "Proszę wpisać nazwę beneficjenta",
      beneficiaryNameInvalid: "Nazwa beneficjenta musi mieć od 2 do 30 znaków",
      beneficiaryIdRequired: "Proszę podać numer identyfikacyjny beneficjenta",
      beneficiaryIdInvalid: "Format numeru identyfikacyjnego beneficjenta jest nieprawidłowy",
      beneficiaryMobileRequired: "Proszę podać telefon komórkowy beneficjenta",
      beneficiaryMobileInvalid: "Format telefonu komórkowego beneficjenta jest nieprawidłowy",
      Ad1: "Prześlij swoją kartę ubezpieczenia społecznego, prawo jazdy lub paszport",
      Ad2: "Prześlij jeden z plików przed przesłaniem",
      Ad3: "Pełne imię i nazwisko",
      Ad4: "Adres kontaktowy",
      Ad5: "Transmisja na żywo",
      Ad6: "Moje życie",
      Ad7: "Dodawanie nie powiodło się, można dodać maksymalnie 3",
      size: "Rozmiar przesyłanego obrazu nie może przekraczać 5M",
      safelevel_low: "Poziom bezpieczeństwa: niski",
      safelevel_high: "Poziom bezpieczeństwa: wysoki",
      safelevel_medium: "Poziom bezpieczeństwa: średni",
      nickname: "Przydomek",
      bind: "Wiązać",
      binded: "Związany",
      verifypass: "Zweryfikowano",
      binding: "Bind",
      binderr: "Awaria",
      bindretry: "Spróbować ponownie",
      verified: "Zweryfikowano",
      notverified: "Nie zweryfikowano",
      verifiedtip: "Aby chronić bezpieczeństwo swojego konta, wypełnij certyfikat prawdziwego imienia i nazwiska, zanim będziesz mógł handlować!",
      realname: "Prawdziwe imię",
      idcard: "Dowód osobisty",
      upload: "Wgrywać",
      upload_positive: "Prześlij zdjęcie identyfikacyjne z przodu",
      upload_negative: "Prześlij zdjęcie odwrotne dowodu osobistego",
      upload_hand: "Przesyłaj zdjęcia z kieszonkowego dokumentu tożsamości",
      save: "Ratować",
      reset: "Nastawić",
      email: "E-mail",
      bindemail: "Powiąż e-mail",
      loginpwd: "Hasło logowania",
      emailcode: "Kod weryfikacyjny e-mail",
      clickget: "Kliknij, aby uzyskać",
      second: "S",
      phone: "Telefon",
      bindphone: "Powiąż telefon",
      phonecode: "Kod weryfikacyjny telefonu",
      logintip: "Użyj podczas logowania się do platformy",
      edit: "Modyfikować",
      oldpwd: "Stare hasło logowania",
      newpwd: "Nowe hasło logowania",
      confirmnewpwd: "Potwierdź nowe hasło",
      fundpwd: "Hasło funduszu",
      fundtip: "W przypadku zmiany środków na koncie należy najpierw zweryfikować hasło do środków",
      set: "Ustawić",
      confirmpwd: "potwierdź hasło",
      oldfundpwd: "Stare hasło do funduszu",
      newfundpwd: "Nowe hasło funduszu",
      newpwdmsg1: "Proszę podać nie mniej niż 6 nowych haseł logowania",
      newpwdmsg2: "Nowe hasło logowania jest niespójne",
      pwdmsg1: "Proszę podać nie mniej niż 6 haseł",
      pwdmsg2: "Niespójne hasło",
      emailtip: "Proszę wpisać e-mail",
      codetip: "Proszę wprowadzić kod weryfikacyjny",
      telnotip: "Proszę podać numer telefonu",
      oldpwdtip: "Proszę podać oryginalne hasło",
      realnametip: "Proszę wpisać swoje prawdziwe imię i nazwisko",
      idcardtip: "Proszę podać numer identyfikacyjny",
      bindphonetip: "Najpierw zwiąż telefon!",
      resetfundpwd: "Zresetuj hasło środków",
      upload_positivetip: "Prześlij zdjęcie z przodu dowodu osobistego",
      upload_negativetip: "Proszę przesłać rewers dowodu osobistego ze zdjęciem",
      upload_handtip: "Prześlij zdjęcia z palmtopa",
      save_success: "Sukces!",
      save_failure: "Awaria!",
      imgtip: "Prześlij swój kod QR, aby otrzymać gotówkę od odbiorcy",
      idcard_verifymsg1: "1. Akta są mniejsze niż 8M. Informacje na dokumencie powinny być wyraźnie widoczne, niedopuszczalne są zmiany w dokumencie lub zakrywanie go przez ciała obce, a także numer i nazwa dokumentu powinny być widoczne.",
      idcard_verifymsg2: "2. Zdjęcie powinno przedstawiać Cię bez kapelusza. Zaleca się nie stosować makijażu. Rysy twarzy osób trzymających dokumenty w ręku powinny być wyraźne, a ramiona powinny być całkowicie odsłonięte.",
      idcard_verifymsg3: "3. Należy przechowywać zarówno dokumenty trzymane w ręku, jak i kopię odręczną (imię i nazwisko + data złożenia wniosku). „Wszystkie moje działania na tej stronie są moją własną działalnością i rozumiem związane z tym ryzyko i jestem gotowy ponieść wszystkie konsekwencje prawne związane z tym kontem”."
    },
    account: {
      pagetitle: "Powiąż konto z prawdziwym imieniem",
      pagetip: "Proszę ustawić metodę płatności. Pamiętaj, aby używać mojego prawdziwego konta",
      backcardno: "Rachunek bankowy",
      backcardtip: "Dane osobistej karty bankowej nie są powiązane",
      modify: "Modyfikować",
      bind: "Wiązać",
      name: "Nazwa",
      bankaccount: "Rachunek bankowy",
      bankbranch: "Oddział banku",
      bankno: "Numer banku",
      confirmbankno: "Potwierdź numer karty",
      fundpwd: "Hasło funduszu",
      save: "Ratować",
      zfbaccount: "Konto Alipay",
      zfbaccounttip: "Konto osobiste Alipay nie jest powiązane",
      wxaccount: "Konto Wechat",
      wxaccounttip: "Konto osobiste Wechat nie jest powiązane",
      banknomsg1: "Proszę podać poprawny numer karty bankowej",
      banknomsg2: "Dwukrotnie wprowadzony numer karty bankowej jest niespójny!",
      verifiedmsg: "Najpierw wykonaj uwierzytelnienie przy użyciu prawdziwego imienia i nazwiska",
      bankaccountmsg: "Wybierz swój bank",
      bankbranchmsg: "Proszę wprowadzić oddział konta",
      banknomsg: "Proszę podać poprawny numer karty bankowej",
      fundpwdmsg1: "Proszę podać prawidłowe hasło funduszu",
      fundpwdmsg2: "Hasło nie może być krótsze niż 6 znaków",
      zfbaccountmsg: "Proszę wprowadzić konto Alipay",
      wxaccountmsg: "Proszę wejść na konto WeChat",
      save_success: "Sukces!",
      save_failure: "Awaria!"
    },
    otcorder: {
      unpaid: "Nie zapłacony",
      paided: "Płatne",
      finished: "Gotowy",
      canceled: "Odwołany",
      appealing: "Pociągający",
      searchtip: "Wprowadź numer zamówienia",
      orderno: "Nr zamówienia",
      created: "Czas",
      symbol: "Moneta",
      type: "Typ",
      type_sell: "sprzedać",
      type_buy: "kupić",
      tradename: "Nazwa handlowa",
      amount: "Kwota",
      money: "Pieniądze",
      fee: "Opłata"
    },
    identity: {
      certified: "już certyfikowany",
      placeholder: "Prosimy o podanie powodu anulowania",
      apply: "Aplikuj, aby stać się firmą",
      become: "Zostań certyfikowaną firmą BIPPAX i ciesz się większymi przywilejami transakcyjnymi",
      zhusnhu: "Firmy korzystają z ekskluzywnych stoisk reklamowych, aby zwiększyć sukces transakcji",
      tijiaoziliao: "Prześlij informacje uwierzytelniające sprzedawcę",
      place: "Prześlij przygotowane informacje uwierzytelniające sprzedawcę na platformę i prześlij je",
      tijiao: "Twój audyt certyfikacji sprzedawcy został przesłany",
      tijiaosuc: "gratulacje Twój certyfikat sprzedawcy został zaliczony",
      tijiaofail: "Przepraszam! Certyfikat Twojego sprzedawcy nie przeszedł pomyślnie",
      zhuxiaotijiao: "Twój wniosek o anulowanie działalności został przesłany",
      shenhefail: "Twój wniosek o anulowanie działalności nie został zatwierdzony",
      shenhesuc: "Twój wniosek o anulowanie działalności został zatwierdzony",
      shangjiazhuxiao: "rezygnacja z działalności",
      shenagain: "recenzja",
      shenheshibai: "Audyt nie powiódł się",
      sheqinggain: "Aby ubiegać się o",
      reason: "powód",
      shenqingtuibao: "Złóż wniosek o pożyczkę",
      getquan: "Masz następujące uprawnienia",
      read: "Przeczytałem i zgadzam się",
      lijishenqing: "Zastosuj natychmiast",
      tips: "podpowiedź",
      wufachexiao: "Jesteś w trakcie operacji anulowania działalności, po potwierdzeniu złożenia wniosku operacji nie będzie można jej cofnąć.",
      suredo: "Czy jesteś pewien, że to zostało zrobione?",
      shuzizichan: "Certyfikat handlu aktywami cyfrowymi",
      gerenzichan: "Certyfikat osobistego zasobu cyfrowego",
      second: {
        line: "Jak aplikować o działalność gospodarczą?",
        step1: "Krok 1: przygotuj wymagane materiały aplikacyjne",
        step1c1: "Przygotuj następującą aplikację:",
        step1c2: "Numer telefonu komórkowego, identyfikator WeChat, numer QQ, certyfikat osobistego zasobu cyfrowego (zdjęcie), certyfikat transakcji na zasobach cyfrowych (zdjęcie)",
        step2: "Krok 2: złóż wniosek",
        step2c: "Aby wypełnić i przesłać materiały do ​​audytu certyfikacji biznesowej, kliknij opcję Prześlij do zatwierdzenia.",
        step3: "Krok 3: audyt danych",
        stepc: "Będziemy przeglądać Twoje zgłoszenia biznesowe przez następne trzy do pięciu dni. Miej oczy otwarte, ale możesz przesłać stronę. Po akceptacji możesz opublikować ogłoszenie w obszarze wymiany walut francuskich.",
        agree: "Zgodziłem się zamrozić",
        agreec: "Jako depozyt handlowy",
        shenqingchngweishangjia: "Złóż wniosek biznesowy"
      },
      yuanyin: "powód",
      bizhong: "Waluta depozytowa",
      shuliang: "Kwota marginesu",
      chosen: "Wybierz walutę",
      seat: "Ekskluzywne stoisko",
      service: "Usługa jeden do jednego",
      lowfee: "Niższe opłaty",
      phone: "Telefon",
      balance: "Majątek osobisty",
      cardphoto: "Pozytywne i negatywne zdjęcia identyfikacyjne",
      wx: "Wechat",
      exchange: "Czy angażować się w handel pozagiełdowy aktywami cyfrowymi",
      handphoto: "Użytkownik posiadający zdjęcie identyfikacyjne",
      qq: "Pytanie",
      ploy: "Czy istnieje odpowiednia strategia kontroli ryzyka",
      agreement: "„Umowa certyfikowanego sprzedawcy”",
      applyfor: "Stosować",
      sendcode: "Wysłać",
      confirm: "Potwierdzać",
      prepare: "Przygotuj materiały",
      result: "Poczekaj na wynik",
      review: "Prześlij recenzję",
      passed: "Recenzja przeszła",
      approve: "Wyraź zgodę na umowę handlową dotyczącą certyfikacji",
      emailtip1: "Prosimy o przesłanie poniższych materiałów na adres e-mail",
      emailtip2: "Rozpatrzymy Twój wniosek tak szybko, jak to możliwe."
    },
    extension: {
      title1: "Linki promocyjne",
      title2: "Promocja znajomych",
      title3: "Moja prowizja",
      linkdesc: "Poniższy adres URL jest Twoim adresem do promocji w świecie zewnętrznym. Możesz promować go za pośrednictwem znajomych, QQ, Wechat, Weibo, blogów, forów lub własnej strony internetowej. Wszystkie osoby, które uzyskały dostęp poprzez ten adres, staną się Twoimi użytkownikami po rejestracji. A kiedy ci użytkownicy przedstawią strategie w tej witrynie, możesz zarabiać prowizje, a szczegółową promocję można zobaczyć w rekordzie dostępu.",
      linktitle: "Twoje linki do romansów",
      copy: "Kopia",
      copy_msg1: "Skopiuj sukces!",
      copy_msg2: "Awaria! Skopiuj go ręcznie",
      username: "Nazwa",
      currrecharge: "Transakcja",
      userlevel: "Poziom użytkownika",
      createdtime: "Czas rejestracji",
      currcommission: "Aktualna prowizja",
      managerfee: "opłata za zarządzanie",
      yuan: "juan (RMB)",
      symbol: "MONETA",
      amount: "Kwota",
      remark: "Uwaga",
      amounttime: "Czas dostawy"
    },
    promotion: {
      title: "Centrum Promocji",
      subtitle1: "Moje karty",
      subtitle2: "Zapisy wymiany",
      subtitle3: "Moja promocja",
      card_column0: "Kod wymiany",
      card_column1: "Nazwa",
      card_column2: "Symbol monety",
      card_column3: "Kwota",
      card_column4: "Termin ostateczny",
      card_column5: "Całkowity",
      card_column6: "Wymienione",
      card_column7: "Stwórz czas",
      my_column0: "Zaproś użytkownika",
      my_column1: "Data rejestracji",
      my_column2: "Prawdziwe imię",
      gopromotion: "Promocja",
      inputcardno: "Proszę wprowadzić kod karty",
      exchange: "Giełda",
      exchangesuccess: "Gratulacje! Możesz sprawdzić zasób w centrum finansowym!",
      exchangewithcode: "Wymiana z kodem"
    },
    activity: {
      navTitle: "Innowacja",
      subNavTitle1: "Moje zamówienia",
      subNavTitle2: "Moje kopalnie",
      subNavTitle3: "Mój zablokowany",
      column1: "Nazwa",
      column2: "Typ",
      column3: "Kwota",
      column4: "Jednostka (IN)",
      column5: "Jednostka (OUT)",
      column6: "Status",
      column7: "Obrót",
      column8: "Stwórz czas",
      mColumn1: "Obraz",
      mColumn2: "Nazwa",
      mColumn3: "Jednostka monet",
      mColumn4: "Okres",
      mColumn5: "Dni Górnictwa",
      mColumn6: "Dni Wydobycia",
      mColumn7: "Status",
      mColumn8: "Pojemność podstawowa",
      mColumn9: "Aktualna pojemność",
      mColumn10: "Całkowite wydobycie",
      mColumn11: "Data zakończenia",
      mColumn12: "Utwórz datę",
      lColumn1: "Obraz",
      lColumn2: "Nazwa",
      lColumn3: "Jednostka monet",
      lColumn4: "Okres",
      lColumn5: "Zablokowane dni",
      lColumn6: "Wydane dni",
      lColumn7: "Status",
      lColumn8: "Pojemność podstawowa",
      lColumn9: "Aktualna pojemność",
      lColumn10: "Całość wydana",
      lColumn11: "Data zakończenia",
      lColumn12: "Utwórz datę"
    },
    mining: {
      title: "Moja lista górnicza",
      empty: "Brak rekordów",
      day: "Dzień",
      week: "Tydzień",
      month: "Miesiąc",
      year: "Rok",
      invitetip1: "Wydajność maszyny kopalnianej można zwiększyć zapraszając znajomych. Każda osoba zaproszona do wymiany maszyny kopalnianej zwiększy jej pojemność",
      invitetip2: "Górna granica wzrostu wydajności",
      miningUnit: "Jednostka Górnicza",
      miningPeriod: "Okres górniczy",
      miningDays: "Czasy górnictwa",
      miningedDays: "Czasy górnictwa",
      miningDaysProfit: "Wyjście podstawowe",
      miningCurrentDaysProfit: "Prąd wyjściowy",
      status0: "Do wdrożenia",
      status1: "Wdrożony",
      status2: "Nad"
    },
    locked: {
      title: "Moja zamknięta lista",
      empty: "Brak rekordów",
      day: "Dzień",
      week: "Tydzień",
      month: "Miesiąc",
      year: "Rok",
      invitetip1: "Pojemność zablokowanego można zwiększyć, zapraszając znajomych. Każda osoba zaproszona do wymiany zamka zwiększy pojemność",
      invitetip2: "Górna granica wzrostu wydajności",
      miningUnit: "Zwolnij jednostkę",
      miningPeriod: "Okres zwolnienia",
      miningDays: "Czasy wydania",
      miningedDays: "Wydane czasy",
      miningDaysProfit: "Wyjście podstawowe",
      miningCurrentDaysProfit: "Prąd wyjściowy",
      status0: "Być uwolnionym",
      status1: "Zwalnianie",
      status2: "Nad",
      totallocked: "Całość zablokowana"
    },
    api: {
      apiAdmin: "Zarządzanie API",
      createApi: "Utwórz nowy klucz API",
      mark: "uwaga",
      bindAddress: "Niepowiązany klucz adresu IP jest ważny przez 90 dni",
      hint: "wskazówka",
      part1: "Udostępniamy Ci potężny interfejs API, możesz korzystać z zapytań rynkowych, transakcji automatycznych i innych usług",
      apiDoc: "według dokumentacji API.",
      howUse: "Zobacz jak używać",
      part2: "Utwórz do 5 zestawów kluczy API na użytkownika",
      part3: "Aby uniknąć utraty mienia, nie ujawniaj swojego klucza API. Ze względów bezpieczeństwa zaleca się powiązanie adresu IP z kluczem API, maksymalnie 5 adresów IP dla każdego klucza API. Wpisz bezpośrednio pojedynczy adres, wiele adresów IP przecinkami w połowie kąta, np. 192.168.1.1, zamiast tego 192.168.1.2, 192.168.1.3.",
      myApiKey: "Mój klucz API",
      ipAddress: "Adres IP",
      createTime: "Utwórz czas",
      accessKey: "Klucz dostępu",
      bindIpAddress: "Powiąż adres IP",
      ioDays: "Pozostałe dni",
      operation: "działanie",
      create: "tworzyć",
      edit: "redagować",
      delete: "usuwać",
      sureDelete: "Czy na pewno chcesz usunąć?",
      tips: "Klucz jest wyświetlany tylko po dodaniu. Zapisz go na czas.",
      copy: "kopia",
      access: "klawisz",
      okText: "Jasne",
      cancel: "anulować"
    }
  },
  cms: {
    noticecenter: "Centrum ogłoszeń",
    newshelp: "Nowy użytkownik pomaga",
    appdownload: "Pobierz aplikację",
    onlineservice: "usługa internetowa",
    faq: "Często zadawane pytania",
    notice: "Ogłoszenie",
    servicecenter: "Centrum Klienta",
    about: "O",
    joinus: "Dołącz do nas",
    aboutus: "O nas",
    exchangerule: "Zasady handlu",
    useprotocol: "Skorzystaj z umowy",
    feenote: "Opis opłaty",
    merchantprocotol: "Umowa handlowa",
    features: "Cechy",
    contactus: "Skontaktuj się z nami",
    noticelist: "Wszystkie ogłoszenia",
    nextnotice: "NASTĘPNY",
    prevnotice: "POPRZED",
    notexist: "Strona, którą odwiedziłeś nie istnieje lub została usunięta",
    otherhelp: "Inne w tej kategorii",
    scanforshare: "Skanuj w celu udostępnienia",
    download: "Pobierać",
    downloadslogan: "APLIKACJA BIPPAX - Handluj wszędzie."
  },
  description: {
    title1: "Bezpieczeństwo",
    title2: "Serwis 24H",
    title3: "Globalna wymiana",
    title4: "Ściśle projekt",
    message1: "Wszechstronny system kontroli finansów finansowych i system antykradzieżowy, portfel gorący i zimny, system wielu podpisów zapewniający bezpieczeństwo środków",
    message2: "Ręczny audyt online 24 godziny na dobę może chronić klientów przed utratą najlepszych okazji inwestycyjnych.",
    message3: "Zasięg globalnej sieci usług biznesowych pomaga inwestować w globalne szyfrowane aktywa i przeprowadzać transakcje z użytkownikami z całego świata",
    message4: "Ściśle wybieramy te wysokiej jakości projekty blockchain, aby odfiltrować dla Ciebie 80% projektów o wyjątkowo wysokim ryzyku.",
    scanqrcode: "Pobierz aplikację",
    aboutdesc1: "BIPPAX.PRO to wiodąca na świecie platforma handlu aktywami cyfrowymi, zarejestrowana na Kajmanach, z głównym zespołem operacyjnym w Hongkongu. Trzonowi członkowie BIPPAX.PRO pochodzą z czołowych firm internetowych i finansowych. Większość z nich głęboko wierzy w Bitcoin i łańcuchy blokowe. Jesteśmy przekonani, że łańcuchy blokowe zmienią tradycyjny monopolistyczny system finansowy i zbudują bardziej demokratyczną i autonomiczną strukturę społeczną.",
    aboutdesc2: "Platforma BIPPAX.PRO posiada profesjonalną architekturę transakcyjną na poziomie finansowym, samodzielnie opracowany silnik transakcyjny o dużej liczbie współbieżnej pamięci. Platforma wykorzystuje system całkowicie zimnych portfeli z możliwością ładowania, wiele podpisów, system ataków DDOS o wysokiej ochronie i inną architekturę handlową, aby zapewnić bezpieczeństwo aktywów klientów.",
    aboutdesc3: "Aby umożliwić klientom lepsze zrozumienie możliwości inwestycyjnych, BIPPAX.PRO przyjmuje płaskie zarządzanie w dziale obsługi klienta i ustanawia niezwykle szybki mechanizm reakcji serwisu. Menedżer ds. obsługi klienta aktywów jest dostępny online 7*24 godziny na dobę przez cały rok, zapewniając klientom takie usługi, jak doładowanie i gotówka, a także dbając o to, aby klienci zakończyli doładowanie w 25 minut.",
    aboutdesc4: "BIPPAX.PRO ściśle monitoruje projekty wysokiej jakości i zapewnia bezpieczne i stabilne usługi hostingu zasobów. BIPPAX.PRO podtrzymuje koncepcję „uczciwości, sprawiedliwości, entuzjazmu i otwartości” i stara się stworzyć bezpieczną, niezawodną, ​​wydajną i przyjazną, ostateczną wymianę dla użytkowników.",
    aboutdesc5: "Chociaż zasoby cyfrowe są obecnie tylko w wąskim kręgu, wierzymy, że tego rodzaju aktywa, które każdy może w pełni zrozumieć, będą popularne w przyszłości. Współpracujmy i nie możemy się doczekać!",
    support: "Wsparcie",
    report: "Sugestia",
    service: "Obsługa klienta",
    apply: "Zarząd Aplikuj",
    coop: "Współpraca",
    community: "Społeczność BIPPAX",
    wechat: "Wechat",
    addwechat: "Dodaj „coinex” do znajomych Wechat, a następnie wejdź do społeczności Wechat",
    weibo: "Weibo",
    twitter: "Świergot",
    biyong: "Biyong",
    telegram: "Telegram",
    medium: "Średni",
    reddit: "Reddit"
  },
  bzb_description: {
    title1: "",
    title2: "",
    title3: "",
    title4: "",
    title5: "",
    title6: "",
    title7: "",
    title8: "",
    desc1: "",
    desc2: "",
    desc3: "",
    desc4: "",
    desc5: "",
    desc6: "",
    desc7: "",
    desc8: ""
  },
  footer: {
    wechatkefu: "usługa wechat",
    notice: "Ogłoszenie",
    gsmc: "Wymień najlepszą kryptowalutę",
    bah: "Nr 13026899 -3, Szanghaj ICP",
    gsjj: "Profil",
    gywm: "O nas",
    jrwm: "Dołącz do nas",
    biyong: "BiYong",
    lxwm: "Skontaktuj się z nami",
    yqlj: "Spinki do mankietów",
    bzzx: "Pomoc",
    xsrm: "Kurs dla początkujących",
    czzn: "Przewodnik ładowania",
    jyzn: "Przewodnik po wymianie",
    ptsm: "Wyjaśnić",
    fysm: "Opłaty",
    fwtk: "Polityka serwisowa",
    fltk: "Polityka prawna",
    wechat: "Obsługa klienta WeChat",
    xszn: "Przewodnik dla początkujących",
    cjwt: "Często zadawane pytania",
    mztk: "Zastrzeżenie",
    ystk: "Polityka prywatności",
    tkxy: "Warunki",
    gybzb: "O BZB",
    kfyx: "Usługa e-mail",
    swhz: "Współpraca",
    sbsq: "Aplikacja rynkowa",
    bzzl: "Informacje o monetach",
    tsjb: "Raport",
    apidoc: "Doktor Api",
    zwkf: "przyjdź wkrótce"
  },
  index: {
    circulation: "Obieg funduszy bezpieczeństwa i rozwoju",
    hourEth: "Skumulowany dochód zostanie rozdzielony w dniu dzisiejszym",
    yesterdayEth: "Skumulowany dochód zostanie rozdzielony we wczoraj",
    yesterday: "Urobek wydobywczy poprzedniego dnia:",
    bhbTotal: "BHB Całkowity strumień",
    bhbSecond: "BHB Dwupoziomowy obieg rynku",
    checkMineprinciple: "Zobacz zasadę wydobycia",
    checkFlowVolum: "Kontrola obiegu",
    checkLockPosition: "Sprawdź stan zamka",
    BHBregister: "Rejestracja konta BIPPAX",
    tibi: "Termin i termin wpłaty pieniędzy do rachunku",
    line_plane: "Ogłoszenie dotyczące planu on-line BHB, nakładu i zwrotu opłat za usługę",
    fenpeijizhi: "Opis mechanizmu dystrybucji dochodów BIPPAX",
    jiangli_jihua: "Zaproszenie do programu nagród górniczych",
    friend_fanhuan: "Zaproś znajomych, zarób dodatkową opłatę i wróć"
  },
  plate: {
    title: "Schemat dystrybucji dochodów platformy (kapitał własny posiadacza BHB)",
    content1: "Jak opisano w białej księdze, BIPPAX przejmie 80% platformy (po odliczeniu podatków i opłat). Dochody są przekazywane posiadaczom BHB, a 20% przychodów jest wykorzystywane na wsparcie badań i rozwoju oraz obsługę platformy.",
    content2: "Podział dochodu trwa dni jako cykl dystrybucji, a 6 czerwca 2018 r. jako pierwszy dzień dystrybucji. Każdego następnego dnia całkowity dochód przypadający na dzień poprzedni będzie przydzielany proporcjonalnie posiadaczom BHB.",
    content3: "(Uwaga: 1. BHB odnosi się tutaj tylko do BHB, które zostało wypuszczone/rozpowszechnione. Zobacz także【",
    content3_1: "Uwaga dotycząca stosunku nakładów BHB do udziału w podziale dochodów",
    content3_2: "2. Migawka godzinowa (całopunktowa) jest obliczana raz, a podział dochodu wykonywany jest raz dziennie.",
    hourFenpei: "Podział dochodów dzisiaj",
    hourTotal: "Całkowity dochód dzisiejszej platformy",
    xiangqing: "Szczegóły dzisiejszego podziału dochodów",
    yesterdaytit: "Podział dochodów wczoraj",
    yesterdaytotal: "Całkowity dochód wczorajszej platformy",
    yesterdayxiangqing: "Szczegóły wczorajszego podziału dochodów",
    yesterday: {
      total: "Całkowite przychody",
      allocated: "Niepodzielone przychody"
    }
  },
  feereturn: {
    ruletitle: "Notatka",
    rulecontent: "W naszej białej księdze znajduje się szczegółowe wyjaśnienie dotyczące zwrotu opłat transakcyjnych. Ogólnie rzecz biorąc, 51% całkowitej bazy BHB platformy (odtąd zwanej „częścią nagrody społeczności”) zostanie z czasem zwrócone użytkownikom za pośrednictwem naszego mechanizmu „Trans-Fee Mining”. Jednakże po całkowitym uwolnieniu tych 51% wszystkich BHB w drodze zwrotu kosztów mechanizm „Trans-Fee Mining” zostanie automatycznie zakończony.",
    recordtitle: "Lista",
    recordcontent: "Codziennie (UTC+8, jak poniżej) BHB zwróci użytkownikowi w formie BHB 100% opłat transakcyjnych poniesionych z poprzedniego dnia. Dokonuje się tego przy użyciu średniej ceny BHB z poprzedniego dnia (ta średnia cena jest obliczana jako całkowita wartość transakcji/całkowity wolumen transakcji). Zwrot opłat transakcyjnych z dnia poprzedniego zrealizujemy w formie BHB codziennie o godzinie 11:00.",
    time: "Data",
    todaycharge: "Średnia cena (ETH)",
    totalChange: "Razem (ETH)",
    returnCharge: "Zwrot kosztów wydobycia za opłatą transakcyjną (BHB)",
    todayChargeReturn: "Program motywacyjny dotyczący zwrotu kosztów FCoin （BHB）"
  },
  home: {
    login: {
      title: "Zacznij handlować kryptowalutami",
      desc: "Obsługa ponad 500 kryptowalut i różnorodnych narzędzi handlowych",
      btnText: "Handluj teraz"
    },
    unlogin: {
      title: "Rozpocznij swoją podróż z zasobami cyfrowymi",
      desc: "Zarejestruj się i ciesz się nowym pakietem prezentów dla użytkowników",
      placinfo: "Telefon/e-mail",
      btnText: "Rejestr"
    },
    WelfareCenter: "Centrum Opieki Społecznej",
    Welcome_ceremony: "Prezent nowego użytkownika",
    Airdrop: "Zrzut",
    DailyGain: "Codzienne nagrody",
    AirdropGift: "Prezenty zrzutowe",
    financial_management: "Zoptymalizowane zarządzanie finansami",
    Zhoude: "Cotygodniowe nagrody",
    height_is: "aż do",
    Happiness: "Karnawał szczęścia",
    Monthly: "Nagrody miesięczne",
    CarveUp: "Pula nagród",
    download: {
      transactions_anytime: "Handluj w dowolnym miejscu i czasie",
      scan_code: "Zeskanuj, aby pobrać",
      download_more: "Pobierz więcej"
    },
    brand: {
      digital_platform: "Wiodąca platforma handlu aktywami cyfrowymi",
      rich_digital: "Bogate usługi handlu aktywami cyfrowymi i zarządzania aktywami w celu zaspokojenia różnorodnych potrzeb handlowych",
      High_quality_digital: "Wysokiej jakości zasoby cyfrowe",
      Turnover: "Obrót",
      safety_risk: "Światowej klasy system zarządzania bezpieczeństwem i ryzykiem",
      multi_factor: "Przechowywanie offline, szyfrowanie wieloczynnikowe, monitorowanie platformy 24 godziny na dobę, 7 dni w tygodniu, kompleksowa ochrona bezpieczeństwa zasobów użytkowników",
      Security_reserve: "Fundusz Rezerwy Bezpieczeństwa",
      accident: "0 wypadków w ciągu 9 lat",
      safetyrisk: "Najwyższy poziom bezpieczeństwa i kontroli ryzyka",
      choice_trusted: "Wybór, któremu zaufały miliony użytkowników",
      transaction_service: "Utworzono zlokalizowane centra usług transakcyjnych w wielu krajach i regionach na całym świecie, tworząc ekosystem blockchain z wieloma formami biznesowymi",
      ten_thousand: "10 000",
      User_preference: "Preferowane przez użytkowników",
      Countries_covered: "Kraje objęte"
    },
    trading: {
      digital_currency: "Rozpocznij swoją podróż z zasobami cyfrowymi",
      register: "Rejestr",
      login: "Zaloguj się",
      currency_transaction: "Zacznij handlować kryptowalutami",
      to_trade: "Handluj teraz"
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/pl/index.js